import { Component, OnInit, AfterViewInit, ViewChild, SimpleChange, ChangeDetectorRef } from '@angular/core';
import { GlobalService } from '../services/global.service';
import { Router } from "@angular/router";
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import Utils from 'app/shared/utility';
import { MatDialog } from '@angular/material/dialog';
import { CurrencyPipe } from '@angular/common';
import { MmtMessageComponent } from '../shared/modal/mmt-message/mmt-message.component';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';
import {ResetHcQuestDataMsgComponent} from '../shared/reset-hc-quest-data-msg/reset-hc-quest-data-msg.component';
import { AddCategoryComponent } from '../shared/modal/add-category/add-category.component';
import { BasicQuestionComponent } from 'app/shared/modal/basic-question/basic-question.component';
import { MessageComponent } from 'app/shared/modal/message/message.component';
import { SidebarService } from '../services/sidebar.service';
// import { fromEvent} from 'rxjs';

export interface reportData {
  type: string;
  createdBy: string;
  createdOn: string;
  action: any;
  reportID: number;
  advisorID: number;
  clientID: number;
  orgID: number;
  reportTypeID: number;
  clientFirstName: string;
  clientLastName: string;
}


@Component({
  selector: 'app-new-edit-client',
  templateUrl: './new-edit-client.component.html',
  styleUrls: ['./new-edit-client.component.css']
})
export class NewEditClientComponent implements OnInit, AfterViewInit {  
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    if (this.dataSourceHCReport) {
      this.dataSourceHCReport.sort = this.sort;
    }
    // this.setDataSourceAttributes();
  }

  @ViewChild('matSortLTC') set matSortLTC(ms: MatSort) {
    this.sortLTC = ms;    
    if(this.dataSourceLTCReport){
      this.dataSourceLTCReport.sort = this.sortLTC;
    }
  }

  @ViewChild('matSortMMT') set matSortMMT(ms: MatSort) {
    this.sortMMT = ms;    
    if(this.dataSourceMMTReport){
      this.dataSourceMMTReport.sort = this.sortMMT;
    }
  }

  @ViewChild('matSortComb') set matSortComb(ms: MatSort) {
    this.sortComb = ms;    
    if(this.dataSourceCombinedReport){
      this.dataSourceCombinedReport.sort = this.sortComb;
    }
  }

  @ViewChild('matSortSS') set matSortSS(ms: MatSort) {
    this.sortSS = ms;    
    if(this.dataSourceSSReport){
      this.dataSourceSSReport.sort = this.sortSS;
    }
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }

  @ViewChild('ssPaginator') set ssPaginator(mp: MatPaginator) {
    this.paginatorSS = mp;
    if(this.dataSourceSSReport){
      this.dataSourceSSReport.paginator = this.paginatorSS;
    }
  }

  @ViewChild('ltcPaginator') set ltcPaginator(mp: MatPaginator) {
    this.paginatorLTC = mp;
    if(this.dataSourceLTCReport){
      this.dataSourceLTCReport.paginator = this.paginatorLTC;
    }
  }

  @ViewChild('combPaginator') set combPaginator(mp: MatPaginator) {
    this.paginatorComb = mp;
    if(this.dataSourceCombinedReport){
      this.dataSourceCombinedReport.paginator = this.paginatorComb;
    }
  }

  @ViewChild('mmtPaginator') set mmtPaginator(mp: MatPaginator) {
    this.paginatorMMT = mp;
    if(this.dataSourceMMTReport){
      this.dataSourceMMTReport.paginator = this.paginatorMMT;
    }
  }

  displayedColumns: string[] = ['type', 'createdBy', 'createdOn', 'action'];
  dataSource: MatTableDataSource<reportData>;
  clientID: number;
  private paginator: MatPaginator;
  private paginatorLTC: MatPaginator;
  private paginatorSS: MatPaginator;
  private paginatorMMT: MatPaginator;
  private paginatorComb: MatPaginator;
  private sort: MatSort;
  private sortLTC: MatSort;
  private sortMMT: MatSort;
  private sortComb: MatSort;
  private sortSS: MatSort;
  public isMMTSectionDisabled: boolean = false;

  public client: any;
  public mAGIBracket: string;
  public ssClientAge: string = '65';
  public ssSpouseAge: string = '65';

  public allStates: any[] = Utils.allStates;

  private navCards = [];
  private navHealthCareCards = [];
  private ssCards = [];
  private ltcCards = [];
  private comboCards = [];
  private mmtCards = [];

  private hcPastReports = [];
  private ltcPastReports = [];
  private mmtPastReports = [];
  private ssPastReports = [];
  private comboPastReports = [];

  magiBracketOneMin: number;
  magiBracketOneMax: number;
  magiBracketTwoMin: number;
  magiBracketTwoMax: number;
  magiBracketThreeMin: number;
  magiBracketThreeMax: number;
  magiBracketFourMin: number;
  magiBracketFourMax: number;
  magiBracketFiveMin: number;
  magiBracketFiveMax: number;
  magiBracketSixMin: number;
  magiBracketSixMax: string;

  cardWidth: number;
  cardHeight: number;
  public clientInfo: any = {
    generalInformation: {
      firstName:'',
      lastName:'',
      gender: '',
      age: '',
      maritalStatus: false,
      retirementAge: '',
      retirementState: ''
    },
    healthInformation: {
      HCC: false,
      HCCD: false,
      HCHBP: false,
      HCHC: false,
      HCT: false,
      HCT2D: false,
      lifeExpectancy: '',
    },
    financialInformation: {
      currentIncome: ''
    },


  };
  error: any;
  public pre65Coverage: any = {
    hasPrivateHealthCareCoverage: '',
    coverageType: '',
    hasSpousePrivateHealthCareCoverage:'',
    spouseCoverageType:'',
    isDisabled: true,
    isShowSpouse: false,
    cardHeight: null
  };

  public medicareCoverage: any = {
    premiumType: '',
    coverageChoices: '',
    spousePremiumType:'',
    spouseCoverageType:'',
    isDisabled: true,
    isShowSpouse: false,
    cardHeight: null

  };

  public income: any = {
    mAGIBracket: '',
    isDisabled: false,
    cardHeight: null
  };

  public LTCMetroArea: any = {
    clientRetirementLocation: '',
    clientMetroArea: '',
    spouseRetirementLocation:'',
    spouseMetroArea:'',
    isDisabled: true,
    isShowSpouse: false
  };

  public SocialSecurity: any = {
    clientAgeStart:'',
    spouseAgeStart:'',
    isDisable: true,
    isAlreadyUpdate: false,
    isShowSpouse: false
  }

  clientLtcStateRegions = [];
  spouseLtcStateRegions = [];

  isLoadingReport: boolean = false;

  listHCReportData: reportData[] = [];

  dataSourceHCReport: MatTableDataSource<reportData>;
  dataSourceLTCReport: MatTableDataSource<reportData>;
  dataSourceCombinedReport: MatTableDataSource<reportData>;
  dataSourceMMTReport: MatTableDataSource<reportData>;
  dataSourceSSReport: MatTableDataSource<reportData>;

  pageSize = 10;

  clientSpouseFullName;
  advisorFirstName: string;
  advisorLastName: string;
  isMarried;//: boolean = false;
  isAlreadyInitializeComponent: boolean = false;

  constructor(public sidebarService: SidebarService, private matDialog: MatDialog, private globalService:GlobalService, private router: Router, public dialog: MatDialog, private snackBarService: SnackBarService, private loadingService: LoadingService, private cdr: ChangeDetectorRef) {
    console.log('window.innerHeight', window.innerHeight);
    
   
  //   fromEvent(window, 'resize').subscribe(() => {
  //     if (window.innerHeight > 770) {
  //       document.getElementById('my-modal').style.height = window.innerHeight + "px"
  //       } else {
  //         document.getElementById('my-modal').style.height = window.outerHeight + "px"
  //       }
  //   }


  // );
  //   fromEvent(window, 'resize').subscribe(() => console.log('window.innerHeight ', window.innerHeight ));

  sidebarService.clientUpdated.subscribe(()=>{
    if (this.isAlreadyInitializeComponent) {
      console.log('sidenav adj');
      this.router.navigate(['/clients/edit']);
    }


  });

  //this.sidebarService.open();
    this.globalService.featQuickReports = JSON.parse(localStorage.getItem('featQuickReports'));
    this.clientID = Number(localStorage.getItem('selectedClient'));
    this.cardWidth = 315;
    this.cardHeight = 235;

    //TODO: 'dataSource' needs to be duplicated for each section with reports (i.e LTC, MMT, SS)
    //right now it is just being used to display HC data; which is also bogus data - need to setup API
    // const reports = Array.from({length: 5}, (_, k) => this.createList(k + 1));
    // this.dataSource = new MatTableDataSource(reports);

    this.globalService.featMeansTesting = JSON.parse(localStorage.getItem('featMeansTesting'));
    this.globalService.featLongTermCare = JSON.parse(localStorage.getItem('featLongTermCare'));
    this.globalService.featSocialSecurity = JSON.parse(localStorage.getItem('featSocialSecurity'));
    this.globalService.featHealthCare = JSON.parse(localStorage.getItem('featHealthCare'));
    this.globalService.featCombinedHealthcareLTC = JSON.parse(localStorage.getItem('featCombinedHealthcareLTC'));          
    this.globalService.featRiskTolerance = JSON.parse(localStorage.getItem('featRiskTolerance'));

    //required for page refresh when updating client profile
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
  }

  // createList(id: number): reportData {
  //    //TODO: this object needs to be able to set the selected report for this client
  //   return {
  //     type: 'Health Care Illustration - Full',
  //     createdBy: 'Client Name',
  //     createdOn: '5/24/2022 10:07am',
  //     action: 'link to report'
  //   };
  // }


  isHealthCareEdit = false;
  isLongTermCareEdit = false;
  isCombinedEdit = false;
  isMeansTestingEdit = false;
  isSocialSecurityEdit = false;
  // setDataSourceAttributes() {
  //   if (this.pageSize) {
  //     this.paginator.pageSize = this.pageSize;
  //   }

  //   this.dataSourceHCReport.paginator = this.dataSourceLTCReport.paginator = this.dataSourceMMTReport.paginator =this.dataSourceSSReport.paginator = this.paginator;
  //   this.dataSourceHCReport.sort = this.dataSourceLTCReport.sort = this.dataSourceMMTReport.sort =  this.dataSourceSSReport.sort = this.dataSourceCombinedReport.sort = this.sort;
  // }
  ngAfterViewInit() {
    // if (this.pageSize) {
    //   this.paginator.pageSize = this.pageSize;
    // }

    // this.dataSourceHCReport.paginator = this.paginator;
    // this.dataSourceHCReport.sort = this.dataSourceLTCReport.sort = this.dataSourceMMTReport.sort =  this.dataSourceSSReport.sort = this.dataSourceCombinedReport.sort = this.sort;
  }
  // this.client.clientProfile.Children.length
// this.client.clientProfile.Pension
// this.inRetEarningForm.value.firstYearRet
// this.client.clientProfile.MonthlyBenefitAmount
// this.client.clientProfile.SSDesiredAgeYears
// check this.client.clientProfile.Spouses.length > 1

  ngOnInit() {
    this.loadingService.isLoading(true);
    this.isAlreadyInitializeComponent = true;

    this.globalService.getClientData(this.clientID, 4)
    .subscribe(
        client => {
          console.log('client',client);
          this.client = client;
          this.advisorFirstName = client.advisor.FirstName;
          this.advisorLastName = client.advisor.LastName;
          this.client.clientProfile.Spouses = JSON.parse(client.clientProfile.Spouses);
          this.isMarried = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? 'true' : 'false';

          // this.clientSpouseFullName = client.clientProfile && client.clientProfile.Spouses[0] && client.clientProfile.Spouses[0].firstName && client.clientProfile.Spouses[0].maritalStatus != 'Widowed' ?
          this.clientSpouseFullName = client.clientProfile && client.clientProfile.Spouses[0] && client.clientProfile.Spouses[0].maritalStatus == 'Married' ?
          (client.client.LastName == client.clientProfile.Spouses[0].lastName) ? 
                client.client.FirstName + ' and ' + client.clientProfile.Spouses[0].firstName + ' ' + client.client.LastName :
                client.client.FirstName + ' ' + client.client.LastName + ' and ' + client.clientProfile.Spouses[0].firstName + ' ' + client.clientProfile.Spouses[0].lastName
                : client.client.FirstName + ' ' + client.client.LastName;

          this.pre65Coverage.hasPrivateHealthCareCoverage = client.clientProfile.IsPrivHealthIns;
          this.pre65Coverage.coverageType = client.clientProfile.CoverageType;
          //this.pre65Coverage.isDisabled = this.pre65Coverage.coverageType ? false : true;
          this.pre65Coverage.hasSpousePrivateHealthCareCoverage = client.clientProfile.IsSpousePrivHealthIns;
          this.pre65Coverage.spouseCoverageType = client.clientProfile.SpouseCoverageType;
          this.pre65Coverage.isShowSpouse = (this.isMarried == 'true')  && (this.pre65Coverage.hasPrivateHealthCareCoverage != this.pre65Coverage.hasSpousePrivateHealthCareCoverage || this.pre65Coverage.coverageType != this.pre65Coverage.spouseCoverageType)? true: false;
          
          if(client.clientProfile.Premiums){
            client.clientProfile.Premiums = JSON.parse(client.clientProfile.Premiums);
          }

          if(client.clientProfile.SpousePremiums){
            client.clientProfile.SpousePremiums  = JSON.parse(client.clientProfile.SpousePremiums);
          }

          this.medicareCoverage.isMedicareCoverage = true;
          this.medicareCoverage.premiumType = client.clientProfile.PremiumType == 'TM' ? 'Traditional Medicare': (client.clientProfile.PremiumType == 'HMO' ? 'Medicare Advantage HMO (w/Rx)':(client.clientProfile.PremiumType == 'PPO' ? 'Medicare Advantage PPO (w/Rx)':''));
          this.medicareCoverage.coverageChoices = client.clientProfile.Premiums ? (client.clientProfile.Premiums.DentalInsurance || client.clientProfile.Premiums.MedicarePartB || client.clientProfile.Premiums.MedicarePartD || client.clientProfile.Premiums.SupplimentalInsurance || client.clientProfile.Premiums.MedicareAdvantagePPO) ? 'Selected' : '': '';
          // this.medicareCoverage.isDisabled = client.clientProfile.PremiumType && this.medicareCoverage.coverageChoices == 'Selected'? false: true;
          this.medicareCoverage.isDisabled = client.clientProfile.PremiumType ? false: true;
          this.medicareCoverage.spousePremiumType = client.clientProfile.SpousePremiumType == 'TM' 
            ? 'Traditional Medicare' : (client.clientProfile.SpousePremiumType == 'HMO' ? 'Medicare Advantage HMO (w/Rx)' : (client.clientProfile.SpousePremiumType == 'PPO' ? 'Medicare Advantage PPO (w/Rx)' : ''));
          this.medicareCoverage.spouseCoverageChoices = client.clientProfile.SpousePremiums ? 'Selected' : '';
          this.medicareCoverage.isShowSpouse =  (this.isMarried == 'true') && (this.medicareCoverage.premiumType != this.medicareCoverage.spousePremiumType || this.medicareCoverage.coverageChoices != this.medicareCoverage.spouseCoverageChoices)? true: false;
          
          this.isHealthCareEdit =  !this.medicareCoverage.isDisabled ? true : false;

          this.pre65Coverage.isDisabled = client.clientProfile.PremiumType && this.medicareCoverage.coverageChoices == 'Selected'? false: true;
          this.income.isDisabled = this.pre65Coverage.isDisabled;

          let clientSpouseFullName = this.client.clientProfile && this.client.clientProfile.Spouses && this.client.clientProfile.Spouses[0].firstName ?
          this.client.client.FirstName + ' and ' + this.client.clientProfile.Spouses[0].firstName + ' ' + this.client.client.LastName
          : this.client.client.FirstName + ' ' + this.client.client.LastName;
          localStorage.setItem('clientSpouseFullName', clientSpouseFullName);
          localStorage.setItem('isMarried', this.isMarried);
          localStorage.setItem('clientFirstName', this.client.client.FirstName );
          if (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].firstName) {
            localStorage.setItem('spouseFirstName', this.client.clientProfile.Spouses[0].firstName);
          }

          this.LTCMetroArea.clientRetirementLocation = client.clientProfile.RetirementState;
          // let clientMetroArea = clientLtcStateRegions.find(({abbreviation}) => abbreviation === client.clientProfile.ClientMetroArea);

          this.getLTCStateRegions(this.client.clientProfile.RetirementState);
          // this.LTCMetroArea.clientMetroArea = clientMetroArea ? clientMetroArea.name : '--';
          if (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].state) {
            this.LTCMetroArea.spouseRetirementLocation = this.client.clientProfile.Spouses[0].state;
            this.getLTCStateRegions(this.client.clientProfile.Spouses[0].state, false)
          }
          // let spouseMetroArea = this.allStates.find(({abbreviation}) => abbreviation === client.clientProfile.SpouseMetroArea);
          // let spouseMetroArea = this.getLTCStateRegions(this.client.clientProfile.Spouses[0].state, false);
          // this.LTCMetroArea.spouseMetroArea = spouseMetroArea ? spouseMetroArea.name : '--';
          // this.LTCMetroArea.isShowSpouse = (this.isMarried == 'true')  && (this.LTCMetroArea.clientMetroArea != this.LTCMetroArea.spouseMetroArea || this.LTCMetroArea.clientRetirementLocation != this.LTCMetroArea.spouseRetirementLocation)? true: false;
          // this.LTCMetroArea.cardHeight =  (this.medicareCoverage.isShowSpouse  || this.pre65Coverage.isShowSpouse || this.LTCMetroArea.isShowSpouse) ?  this.cardHeight: null;
          // this.medicareCoverage.cardHeight =  (this.medicareCoverage.isShowSpouse  || this.pre65Coverage.isShowSpouse || this.LTCMetroArea.isShowSpouse) ? this.cardHeight: null;
          // this.pre65Coverage.cardHeight =  (this.medicareCoverage.isShowSpouse  || this.pre65Coverage.isShowSpouse || this.LTCMetroArea.isShowSpouse) ? this.cardHeight: null;
          // let isPre65 = (Number(this.client.clientProfile.RetirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.client.client.DOB)) >= 65) ? false: true;
          // let includePartner = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? 'true' : 'false';
          // let isSpousePre65 = includePartner ? ((Number(client.clientProfile.Spouses[0].retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(client.clientProfile.Spouses[0].dob)) >= 65) ? false: true): true;
          // this.isHealthCareEdit = ((!this.pre65Coverage.isDisabled || (!isPre65 || !isSpousePre65))  && !this.medicareCoverage.isDisabled) ? true : false;
          
          /* if (this.client.clientProfile.SSDesiredAgeYears) {
            this.SocialSecurity.isAlreadyUpdate = this.client.clientProfile.SSDesiredAgeYears > 0 ? true : false;
          } */
          this.SocialSecurity.isAlreadyUpdate = this.client.clientProfile.PIA > 0 ? true : false;

          let spouseDOB;
          if (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].dob) {
            spouseDOB = this.client.clientProfile.Spouses[0].dob;
          }
          let spouseClaimStartAge;
          if (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].sSDesiredAgeYears) {
            spouseClaimStartAge = this.client.clientProfile.Spouses[0].sSDesiredAgeYears;
          }
          //this.SocialSecurity.clientAgeStart = this.client.clientProfile.SSDesiredAgeYears ? this.determineClaimAge(this.client.client.DOB, this.client.clientProfile.SSDesiredAgeYears): '--';
          this.SocialSecurity.clientAgeStart = this.client.clientProfile.SSDesiredAgeYears ? this.client.clientProfile.SSDesiredAgeYears : '--';
          //this.SocialSecurity.spouseAgeStart = (spouseDOB && spouseClaimStartAge) ? this.determineClaimAge(spouseDOB, spouseClaimStartAge):'--';
          this.SocialSecurity.spouseAgeStart = (spouseDOB && spouseClaimStartAge) ? spouseClaimStartAge : '--';
          this.SocialSecurity.isDisable = (this.client.clientProfile.PIA || (this.SocialSecurity.clientAgeStart != '--' || this.SocialSecurity.spouseAgeStart != '--') || (this.client.clientProfile.HouseholdYearOneIncome > 0 || this.client.clientProfile.CurrentIncome > 0)) ? false : true;
          this.SocialSecurity.isShowSpouse =  (this.isMarried == 'true');
          //console.log('ss cards', this.ssCards);
          this.isSocialSecurityEdit = this.client.clientProfile.CurrentIncome >= 0 
            && ((this.client.clientProfile.Spouses.length > 1 && this.isMarried == 'true') ? (this.client.clientProfile.Spouses[0].currentIncome >= 0) ? true : false : true) 
            && (this.client.clientProfile.SelfKnownBenefitClaiming >= 0
              || this.client.clientProfile.PIA >= 0
              || this.client.clientProfile.Pension 
              || this.client.clientProfile.InRetFirstYearIncome 
              || this.client.clientProfile.MonthlyBenefitAmount 
              || this.client.clientProfile.SSDesiredAgeYears 
              || this.client.clientProfile.Spouses.length > 1) ? true : false;
          console.log('this.isSocialSecurityEdit', this.isSocialSecurityEdit);
          console.log('this.SocialSecurity.isDisable', this.SocialSecurity.isDisable)
          if(!this.SocialSecurity.isDisable){
            //this was created to do various checks in the Client Hub for SS, as needed
            this.socialSecurityCheck();
          }

          //if client has bracket dont allow use of MMT section
          if(this.client.clientProfile.Bracket){
            this.isMMTSectionDisabled = true;
          }
      
          this.loadingService.isLoading(false);
      },
      error => this.error = <any>error);
  }

  socialSecurityCheck(){
    //If a desired claim age is entered, then the user comes back in a future month and the previous desired claim month is no longer valid* then the Alternate should be cleared out altogether 
      //(including for both spouses even if only one has this issue).
      //Could be due to retro claim age 6 month movement, passing a future claim age, or a change to the client profile, or even a future legislative change
    var hasClientDCABeenCleared = false;
    if(this.client.clientProfile.SSDesiredAgeYears || this.client.clientProfile.SurvivorSwitchYears){
      //is same year as DCA, or past it? (first do a simple check based on year/age)
      let clientMonthIndex = new Date(this.client.client.DOB).getMonth() + 1 == new Date().getMonth() + 1 ? 0 
        : (new Date(this.client.client.DOB).getMonth() + 1 > new Date().getMonth() + 1)
        ? (new Date(this.client.client.DOB).getMonth() + 1) - (new Date().getMonth() + 1) 
        : (new Date().getMonth() + 1) - (new Date(this.client.client.DOB).getMonth() + 1);
      console.log('clientMonthIndex', clientMonthIndex);
      console.log('dont remove displayDCANotification', this.client.clientProfile.SSDesiredAgeYears * 12) + this.client.clientProfile.SSDesiredAgeMonths;      
      console.log('dont remove displayDCANotification', ((this.calculateAge(this.client.client.DOB) * 12) + clientMonthIndex));
      console.log('this.client.clientProfile', this.client.clientProfile);
      if(((this.client.clientProfile.SSDesiredAgeYears * 12) + this.client.clientProfile.SSDesiredAgeMonths < ((this.calculateAge(this.client.client.DOB) * 12) + clientMonthIndex)        
        && ((this.calculateAge(this.client.client.DOB) * 12) + clientMonthIndex) - ((this.client.clientProfile.SSDesiredAgeYears * 12) + this.client.clientProfile.SSDesiredAgeMonths) > 1)
        || 
        ((this.client.clientProfile.SurvivorSwitchYears) ? 
        (this.client.clientProfile.SurvivorSwitchYears * 12) + this.client.clientProfile.SurvivorSwitchMonths < ((this.calculateAge(this.client.client.DOB) * 12) + clientMonthIndex)
        && ((this.calculateAge(this.client.client.DOB) * 12) + clientMonthIndex) - ((this.client.clientProfile.SurvivorSwitchYears * 12) + this.client.clientProfile.SurvivorSwitchMonths) > 1 
        : false)) { 
        
        console.log('client DCA in months', (this.client.clientProfile.SSDesiredAgeYears * 12) + this.client.clientProfile.SSDesiredAgeMonths);
        console.log('client current age in months', (this.calculateAge(this.client.client.DOB) * 12) + clientMonthIndex);// + (13 - (new Date(this.client.client.DOB).getMonth())));
        console.log('client diff between DCA and Current', ((this.calculateAge(this.client.client.DOB) * 12) + clientMonthIndex) - ((this.client.clientProfile.SSDesiredAgeYears * 12) + this.client.clientProfile.SSDesiredAgeMonths));
        
        this.SocialSecurity.clientAgeStart = '--';
        if(this.SocialSecurity.isShowSpouse){
          this.SocialSecurity.spouseAgeStart = '--';
        }
        hasClientDCABeenCleared = true;

        this.updateClientProfileRemoveDCA();

        localStorage.setItem('displayDCANotification', 'true');
      }
    } else {
      localStorage.removeItem('displayDCANotification');
    }

    //do the same if spouse exists
    if(this.SocialSecurity.isShowSpouse && !hasClientDCABeenCleared){   
      if(this.client.clientProfile.Spouses[0].sSDesiredAgeYears || this.client.clientProfile.Spouses[0].SurvivorSwitchYears) {
        let clientMonthIndex = new Date(this.client.clientProfile.Spouses[0].dob).getMonth() + 1 == new Date().getMonth() + 1 ? 0 
          : new Date(this.client.clientProfile.Spouses[0].dob).getMonth() + 1 > new Date().getMonth() + 1 
          ? (new Date(this.client.clientProfile.Spouses[0].dob).getMonth() + 1) - (new Date().getMonth() + 1)
          : (new Date().getMonth() + 1) - (new Date(this.client.clientProfile.Spouses[0].dob).getMonth() + 1);

          console.log('spouseclientMonthIndex', clientMonthIndex);
          console.log('spouse dont remove displayDCANotification', (this.client.clientProfile.Spouses[0].sSDesiredAgeYears * 12) + this.client.clientProfile.Spouses[0].sSDesiredAgeMonths);      
          console.log('spouse dont remove displayDCANotification', ((this.calculateAge(this.client.clientProfile.Spouses[0].dob) * 12) + clientMonthIndex));
          //console.log('spouse dont remove displayDCANotification', ((this.calculateAge(this.client.clientProfile.Spouses[0].dob) * 12) + clientMonthIndex));
        
        if(((this.client.clientProfile.Spouses[0].sSDesiredAgeYears * 12) + this.client.clientProfile.Spouses[0].sSDesiredAgeMonths < ((this.calculateAge(this.client.clientProfile.Spouses[0].dob) * 12) + clientMonthIndex)        
          && ((this.calculateAge(this.client.clientProfile.Spouses[0].dob) * 12) + clientMonthIndex) - ((this.client.clientProfile.Spouses[0].sSDesiredAgeYears * 12) + this.client.clientProfile.Spouses[0].sSDesiredAgeMonths) > 1)
          ||
          ((this.client.clientProfile.Spouses[0].SurvivorSwitchYears) ? 
          (this.client.clientProfile.Spouses[0].SurvivorSwitchYears * 12) + this.client.clientProfile.Spouses[0].SurvivorSwitchMonths < ((this.calculateAge(this.client.clientProfile.Spouses[0].dob) * 12) + clientMonthIndex)
          && ((this.calculateAge(this.client.clientProfile.Spouses[0].dob) * 12) + clientMonthIndex) - ((this.client.clientProfile.Spouses[0].SurvivorSwitchYears * 12) + this.client.clientProfile.Spouses[0].SurvivorSwitchMonths) > 1
          : false)){ 
          
          console.log('spouse DCA in months', (this.client.clientProfile.Spouses[0].sSDesiredAgeYears * 12) + this.client.clientProfile.Spouses[0].sSDesiredAgeMonths);
          console.log('spouse current age in months', (this.calculateAge(this.client.clientProfile.Spouses[0].dob) * 12) + clientMonthIndex);// + (13 - (new Date(this.client.client.DOB).getMonth())));
          console.log('spouse diff between DCA and Current', ((this.calculateAge(this.client.clientProfile.Spouses[0].dob) * 12) + clientMonthIndex) - ((this.client.clientProfile.Spouses[0].sSDesiredAgeYears * 12) + this.client.clientProfile.Spouses[0].sSDesiredAgeMonths));
          
          this.SocialSecurity.clientAgeStart = '--';
          this.SocialSecurity.spouseAgeStart = '--';

          this.updateClientProfileRemoveDCA();

          localStorage.setItem('displayDCANotification', 'true');
        }
      } else {
        
      }
    } else {
      //localStorage.removeItem('displayDCANotification');
    }

    if (this.isAlreadyInitializeComponent) {
      //need to push changes to the sidenav for display purposes
      this.sidebarService.ignorePageRefresh = true;
      //this.sidebarService.pushUpdatesToClient(true);

    }
  }

  updateClientProfileRemoveDCA(){
    //NOTE: all this is doing is removing the DCA from the client profile (for client and spouse)
    var UserModel = {
      ID: this.client.client ? this.client.client.ID : 0,
      FirstName: this.client.client.FirstName,
      LastName: this.client.client.LastName,
      AdvisorID: this.client.client.AdvisorID,
      OrganizationID: this.client.client.OrganizationID,
      Username: this.client.client.Username,
      GenderID: this.client.client.GenderID,
      DOB: this.client.client.DOB,
      Email: this.client.client.Email,
      Phone: this.client.client.Phone,
      Address: this.client.client.Address,
      City: this.client.client.City,
      State: this.client.client.State,
      Zip: this.client.client.Zip,
    }

    if(this.isMarried == 'true'){
      this.client.clientProfile.Spouses[0].sSDesiredAgeYears = 0;//data.spouseAgeYears;
      this.client.clientProfile.Spouses[0].sSDesiredAgeMonths = 0;//data.spouseAgeMonths;
    }

    var ClientProfile = {
      ClientID: this.client.clientProfile.ClientID,
      MaritalStatus: this.client.clientProfile.MaritalStatus,
      CurrentIncome: this.client.clientProfile.CurrentIncome,
      IRR: this.client.clientProfile.IRR,
      SelfIRR: this.client.clientProfile.IRR,
      RetirementAge: this.client.clientProfile.RetirementAge,
      RetirementState: this.client.clientProfile.RetirementState,
      SpouseID: this.client.clientProfile.SpouseID,
      LifeExpectancy: this.client.clientProfile.LifeExpectancy,
      HCHBP: this.client.clientProfile.HCHBP ? 1 : 0,
      HCHC: this.client.clientProfile.HCHC ? 1 : 0,
      HCT2D: this.client.clientProfile.HCT2D ? 1 : 0,
      HCCD: this.client.clientProfile.HCCD ? 1 : 0,
      HCC: this.client.clientProfile.HCC ? 1 : 0,
      HCT: this.client.clientProfile.HCT ? 1 : 0,      
      HCT1D: this.client.clientProfile.HCT1D ? 1 : 0,
      HCMS: this.client.clientProfile.HCMS ? 1 : 0,
      HCDCW: this.client.clientProfile.HCDCW ? 1 : 0,
      HCFHDC: this.client.clientProfile.HCFHDC ? 1 : 0,

      HCALZ: this.client.clientProfile.HCALZ ? 1 : 0,
      HCPARK: this.client.clientProfile.HCPARK ? 1 : 0,
      HCAMP: this.client.clientProfile.HCAMP ? 1 : 0,
      HCPTSD: this.client.clientProfile.HCPTSD ? 1 : 0,
      HCOBS: this.client.clientProfile.HCOBS ? 1 : 0,
      
      HCCDYrsDiag: this.client.clientProfile.HCCDYrsDiag ? 1 : 0,
      HCCYrsDiag: this.client.clientProfile.HCCYrsDiag ? 1 : 0,      
      Children: this.client.clientProfile.Children,//JSON.stringify(this.client.clientProfile.Children),
      IncludePension: this.client.clientProfile.IncludePension,      
      SelfPIA: (this.client.clientProfile.PIA) ? this.client.clientProfile.PIA : 0,
      PIA: this.client.clientProfile.PIA,
      SelfAlreadyCollecting: this.client.clientProfile.SelfAlreadyCollecting,
      SelfCurrentMonthlyBenefit: this.client.clientProfile.SelfCurrentMonthlyBenefit,//this is usually defaulted as an empty string is no value (not sure if thats an issue)
      MonthlyBenefitAmount: this.client.clientProfile.MonthlyBenefitAmount,//this is usually defaulted as an empty string is no value (not sure if thats an issue)
      SpouseAlreadyCollecting: this.client.clientProfile.SpouseAlreadyCollecting, 
	    SpouseCurrentMonthlyBenefit: this.client.clientProfile.SpouseCurrentMonthlyBenefit,//this is usually defaulted as 0 if no value (not sure if thats an issue)
      UseNationalAverage: this.client.clientProfile.UseNationalAverage,
      IsRunReportWithSpouse: this.client.clientProfile.IsRunReportWithSpouse,
      IsLegalSpouse: this.client.clientProfile.IsLegalSpouse,
      IsPrivHealthIns: this.client.clientProfile.IsPrivHealthIns,
      CoverageType: this.client.clientProfile.CoverageType,
      PremiumType: this.client.clientProfile.PremiumType,
      Premiums: JSON.stringify(this.client.clientProfile.Premiums),
      IsHSApplySpouse: this.client.clientProfile.IsHSApplySpouse,
      IsSpousePrivHealthIns: this.client.clientProfile.IsSpousePrivHealthIns,
      SpouseCoverageType: this.client.clientProfile.SpouseCoverageType,
      SpousePremiumType: this.client.clientProfile.SpousePremiumType,
      SpousePremiums: JSON.stringify(this.client.clientProfile.SpousePremiums),
      Bracket: this.client.clientProfile.Bracket,
      InflationRate: this.client.clientProfile.InflationRate ,
      HouseholdYearOneIncome: this.client.clientProfile.HouseholdYearOneIncome,
      HouseholdYearOneIncomeChangeYear: this.client.clientProfile.HouseholdYearOneIncomeChangeYear,
      InRetirementInflationRate: this.client.clientProfile.InRetirementInflationRate,
      MAGIPercentIncome: this.client.clientProfile.MAGIPercentIncome,
      OOPCosts: this.client.clientProfile.OOPCosts,
      SpouseOOPCosts: this.client.clientProfile.SpouseOOPCosts,
      ClientMetroArea: this.client.clientProfile.ClientMetroArea,
      SpouseMetroArea: this.client.clientProfile.SpouseMetroArea,
      Pension: this.client.clientProfile.Pension,
      PensionMonths: this.client.clientProfile.PensionMonths,
      PensionYears: this.client.clientProfile.PensionYears,
      SubstantialEarningYears: this.client.clientProfile.SubstantialEarningYears,//this looks like it defaults to a string but is an int here???
      Spouses: JSON.stringify(this.client.clientProfile.Spouses),
      InRetFirstYearIncome: this.client.clientProfile.InRetFirstYearIncome,
      InRetStopWorkAge: this.client.clientProfile.InRetStopWorkAge, //this is usually defaulted as an empty string is no value (not sure if thats an issue)

      SSDesiredAgeYears: 0,//data.clientAgeYears,// data.clientAgeYears,//this.client.clientProfile.SSDesiredAgeYears,
      SSDesiredAgeMonths: 0,//data.clientAgeMonths,//data.clientAgeMonths,//this.client.clientProfile.SSDesiredAgeMonths,

      SurvivorSwitchYears: 0,//data.survivorSwitchAgeYears,// data.survivorSwitchAgeYears,
      SurvivorSwitchMonths: 0,//data.survivorSwitchAgeMonths,

      SelfKnownBenefitClaiming: (this.client.clientProfile.SelfKnownBenefitClaiming) ? this.client.clientProfile.SelfKnownBenefitClaiming : 0,
      SpouseKnownBenefitClaiming: (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0) ? this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming : 0,
      
      SelfFilingRestrictedYear: 0,
      SelfFilingRestrictedMonth: 0,
      SpouseFilingRestrictedYear: 0,
      SpouseFilingRestrictedMonth: 0,
      DateOfClaimMonth: (this.client.clientProfile.SelfAlreadyCollecting > 0) ? this.client.clientProfile.DateOfClaimMonth : 0,
      DateOfClaimYear: (this.client.clientProfile.SelfAlreadyCollecting > 0) ? this.client.clientProfile.DateOfClaimYear : 0,

      SelfWidowYearOfStatement: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : 0 : 0,
      SelfWidowYearTimeOfPassing: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearAtTimeOfPassing) ? this.client.clientProfile.Spouses[0].yearAtTimeOfPassing : 0 : 0,
      YearOfStatement: this.client.clientProfile.YearOfStatement,
           
      InvertSurvivorSwitch: this.client.clientProfile.InvertSurvivorSwitch
     }
     
     //TODO: do I need these??? Set to default null
    var MidRetirementAdj = null;
    let LstMAGIProj = null;
    var AdditionalQuestion = null;
    var RiskTolerance = null;
    console.log('Update Client from Client Hub Page', ClientProfile);
    this.globalService.createClient(UserModel, ClientProfile , RiskTolerance, AdditionalQuestion, MidRetirementAdj, LstMAGIProj)
    .subscribe(
      resp => {
      },
      error => {
        this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
      });
  }

  getLTCStateRegions(state, isClient = true){
    let result = [];
    this.globalService.getLTCStateRegions(state)
      .subscribe(
          data => {
            if (isClient) {
              this.clientLtcStateRegions = data.Rows;
              // need to pass null otherwise display as "State Average"
              this.client.clientProfile.ClientMetroArea = this.client.clientProfile.ClientMetroArea ? this.client.clientProfile.ClientMetroArea: null;
              let clientMetroArea = this.clientLtcStateRegions.find(o  => o.MetroRegionCode == this.client.clientProfile.ClientMetroArea);
              this.LTCMetroArea.clientMetroArea = clientMetroArea ? clientMetroArea.MetroRegion : '--';
              // this.LTCMetroArea.isDisabled = (this.LTCMetroArea.clientRetirementLocation && clientMetroArea) || this.LTCMetroArea.clientRetirementLocation == 'NA' ? false: true;
              // this.isLongTermCareEdit = (this.LTCMetroArea.clientRetirementLocation && clientMetroArea) || (this.LTCMetroArea.clientRetirementLocation == 'NA') ? true: false;
              this.isCombinedEdit = (this.isHealthCareEdit && this.isLongTermCareEdit) ? true : false;
              this.isMeansTestingEdit = (this.client.clientProfile.CurrentIncome || this.client.clientProfile.HouseholdYearOneIncome || this.client.clientProfile.Bracket)
              this.getMMTBracket();
            } else {
              this.spouseLtcStateRegions = data.Rows;
              console.log('this.spouseLtcStateRegions', this.spouseLtcStateRegions);
              this.client.clientProfile.SpouseMetroArea = this.client.clientProfile.SpouseMetroArea ? this.client.clientProfile.SpouseMetroArea : null;
              let spouseMetroArea = this.spouseLtcStateRegions.find(o  => o.MetroRegionCode == this.client.clientProfile.SpouseMetroArea);
              this.LTCMetroArea.clientMetroArea = this.LTCMetroArea.clientMetroArea ? this.LTCMetroArea.clientMetroArea: '--';
              this.LTCMetroArea.spouseMetroArea = spouseMetroArea ? spouseMetroArea.MetroRegion : '--';
              this.LTCMetroArea.isShowSpouse = (this.isMarried == 'true')  && (this.LTCMetroArea.clientMetroArea != this.LTCMetroArea.spouseMetroArea || this.LTCMetroArea.clientRetirementLocation != this.LTCMetroArea.spouseRetirementLocation)? true: false;
              this.LTCMetroArea.cardHeight =  (this.medicareCoverage.isShowSpouse  || this.pre65Coverage.isShowSpouse || this.LTCMetroArea.isShowSpouse) ?  this.cardHeight: null;
              this.medicareCoverage.cardHeight =  (this.medicareCoverage.isShowSpouse  || this.pre65Coverage.isShowSpouse || this.LTCMetroArea.isShowSpouse) ? this.cardHeight: null;
              this.pre65Coverage.cardHeight =  (this.medicareCoverage.isShowSpouse  || this.pre65Coverage.isShowSpouse || this.LTCMetroArea.isShowSpouse) ? this.cardHeight: null;

            }
          },
          error => console.log(error));
          
  }

  getMMTBracket() {
    let includePartner = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? 'true' : 'false';
    var currentYear = new Date().getFullYear();
    let clientRetirementYear = Math.max(currentYear, this.globalService.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
    let spouseRetirementYear = includePartner ? Math.max(currentYear, this.globalService.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)): null;
    let bracketYear = includePartner ? (spouseRetirementYear < clientRetirementYear ? spouseRetirementYear: clientRetirementYear) : clientRetirementYear;
    console.log('bracketYear', bracketYear);
    this.globalService.getMMTBracket(includePartner, currentYear)
            .subscribe(
                data => {
                  this.getReports();
                  this.getMAGIBracket(data);
                  this.assignValueToCards();                  
                },
                error => {
                  console.log('error MMT area', error);
                });
  }

  getMAGIBracket(data) {
    this.magiBracketOneMin = data.Bracket1 ? data.Bracket1: 0;
    this.magiBracketOneMax = data.Bracket2 ? data.Bracket2 - 1 : 0;

    this.magiBracketTwoMin = data.Bracket2 ? data.Bracket2 : 0;
    this.magiBracketTwoMax = data.Bracket3 ? data.Bracket3 - 1 : 0;

    this.magiBracketThreeMin = data.Bracket3 ? data.Bracket3 : 0;
    this.magiBracketThreeMax = data.Bracket4 ? data.Bracket4 - 1 : 0;

    this.magiBracketFourMin = data.Bracket4 ? data.Bracket4 : 0;
    this.magiBracketFourMax = data.Bracket5 ? data.Bracket5 - 1 : 0;

    this.magiBracketFiveMin = data.Bracket5 ? data.Bracket5 : 0;
    this.magiBracketFiveMax = data.Bracket6 ? data.Bracket6 - 1 : 0;

    this.magiBracketSixMin = data.Bracket6 ? data.Bracket6 : 0;
    this.magiBracketSixMax= 'more';

    let bracket;
    if (this.client.clientProfile.Bracket) {
      bracket = this.client.clientProfile.Bracket
    } else {
      bracket =  this.client.clientProfile.CurrentIncome ? this.bracketAssign(this.client.clientProfile.CurrentIncome):'';
    }

    if (bracket == 1) {
      this.income.mAGIBracket = '$' + this.magiBracketOneMax.toLocaleString() + ' or less';
    } else if (bracket == 2) {
      this.income.mAGIBracket = '$' + this.magiBracketTwoMin.toLocaleString()  + ' to '+ '$' + this.magiBracketTwoMax.toLocaleString();
    } else if (bracket == 3) {
      this.income.mAGIBracket = '$' + this.magiBracketThreeMin.toLocaleString() + ' to '+ '$' + this.magiBracketThreeMax.toLocaleString() ;
    } else if (bracket == 4) {
      this.income.mAGIBracket = '$' + this.magiBracketFourMin.toLocaleString() + ' to '+ '$' + this.magiBracketFourMax.toLocaleString() ;
    } else if (bracket == 5) {
      this.income.mAGIBracket = '$' + this.magiBracketFiveMin.toLocaleString() + ' to '+ '$' + this.magiBracketFiveMax.toLocaleString() ;
    } else if (bracket == 6) {
      this.income.mAGIBracket = 'above $' + this.magiBracketSixMin.toLocaleString();
    }
  }

  bracketAssign(percentMAGI) {
    let bracketValue;
    if (percentMAGI >= this.magiBracketOneMin && percentMAGI <= this.magiBracketOneMax) {
      bracketValue = 1;
    }
    if (percentMAGI >= this.magiBracketTwoMin && percentMAGI <= this.magiBracketTwoMax) {
      bracketValue = 2;
    }
    if (percentMAGI >= this.magiBracketThreeMin && percentMAGI <= this.magiBracketThreeMax) {
      bracketValue = 3;
    }
    if (percentMAGI >= this.magiBracketFourMin && percentMAGI <= this.magiBracketFourMax) {
      bracketValue = 4;
    }
    if (percentMAGI >= this.magiBracketFiveMin && percentMAGI <= this.magiBracketFiveMax) {
      bracketValue = 5;
    }
    if (percentMAGI >= this.magiBracketSixMin && percentMAGI <= this.magiBracketSixMax) {
      bracketValue = 6;
    }
    return bracketValue;


  }

  assignValueToCards() {
    console.log('assign values');
    // personal information
    this.clientInfo.generalInformation.firstName = this.client.client.FirstName;
    this.clientInfo.generalInformation.lastName = this.client.client.LastName;
    this.clientInfo.generalInformation.age = this.calculateAge(this.client.client.DOB);
    this.clientInfo.generalInformation.gender = this.client.client.GenderID == 1 ? 'Female': 'Male';
    this.clientInfo.generalInformation.maritalStatus = this.client.clientProfile.maritalStatus == 0 ? 'Single': 'Married';
    // health information
    this.clientInfo.healthInformation.HCC = this.client.clientProfile.HCC == 1 ? true : false;
    this.clientInfo.healthInformation.HCCD = this.client.clientProfile.HCCD == 1 ? true : false;
    this.clientInfo.healthInformation.HCHBP = this.client.clientProfile.HCHBP == 1 ? true : false;
    this.clientInfo.healthInformation.HCHC = this.client.clientProfile.HCHC == 1 ? true : false;
    this.clientInfo.healthInformation.HCT = this.client.clientProfile.HCT == 1 ? true : false;
    this.clientInfo.healthInformation.HCT2D = this.client.clientProfile.HCT2D == 1 ? true : false;
    this.clientInfo.healthInformation.lifeExpectancy = this.client.clientProfile.LifeExpectancy;
    let healthInformation = this.client.clientProfile.HCC == 1 ? ',cancer': '' 
    +  (this.client.clientProfile.HCCD == 1) ? ',cardiovascular disease': '' 
    + (this.client.clientProfile.HCHBP == 1) ? ',high blood pressure ,': '';
    + (this.client.clientProfile.HCHC == 1) ? ',high cholesterol': '';
    + (this.client.clientProfile.HCT == 1) ? ',tobacco ,': '';
    + (this.client.clientProfile.HCT2D == 1) ? ',type 2 diabetes ,': '';
    // income information
    let modifiedAGI = '$0 - $'+ this.client.clientProfile.CurrentIncome
    // retirement information
    this.clientInfo.generalInformation.retirementAge = this.client.clientProfile.RetirementAge;
    this.clientInfo.generalInformation.retirementState = this.client.clientProfile.RetirementState;
    this.navCards = [{ title: 'Personal Information', field1Label: 'Age', field1Value: this.clientInfo.generalInformation.age,field2Label:'Sex at Birth', field2Value: this.clientInfo.generalInformation.gender, field3Value: this.clientInfo.generalInformation.maritalStatus,  image: '../../../assets/icons/user_icon.svg',  isEditClient: true, showQuestionnaire: false, isDisabled: true },
    { title: 'Health Information', field1Label: 'Conditions', field1Value: healthInformation, field3Label:'LifeExpectancy', field3Value: this.clientInfo.healthInformation.lifeExpectancy, image: '../../../assets/icons/health_icon.svg',  isEditClient: true, showQuestionnaire: false, isDisabled: true },
    { title: 'Income Information', field1Label: 'Modified AGI', field1Value: modifiedAGI, image: '../../../assets/icons/money.svg',  isEditClient: true, showQuestionnaire: false, isDisabled: true },
    //{ title: 'Retirement Information', field1Label: 'Retirement Age', field1Value: this.clientInfo.generalInformation.retirementAge,field3Label:'Retirement State', field3Value: this.clientInfo.generalInformation.retirementState, image: '../../../assets/icons/retirement.svg',  isEditClient: true, showQuestionnaire: false, isDisabled: true },
    ];
    let isPrivateHealthCareCoverage = this.pre65Coverage.hasPrivateHealthCareCoverage == null ? '--': (this.pre65Coverage.hasPrivateHealthCareCoverage ? 'Yes': 'No');
    let isSpousePrivateHealthCareCoverage = this.pre65Coverage.hasSpousePrivateHealthCareCoverage == null ? '--': (this.pre65Coverage.hasSpousePrivateHealthCareCoverage ? 'Yes': 'No');
    let isPre65 = (Number(this.client.clientProfile.RetirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.client.client.DOB)) >= 65) ? false: true;
    console.log('isPre65', isPre65);
    console.log('this.medicareCoverage.premiumType', this.medicareCoverage.premiumType)
    let isSpousePre65 = ((Number(this.client.clientProfile.Spouses[0].retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.client.clientProfile.Spouses[0].dob)) >= 65) ? false
      : (this.client.clientProfile.Spouses[0].dob && this.client.clientProfile.Spouses[0].retirementAge) ? true : false);
    let isPre65Disable = this.isMarried == 'true' ? (!isPre65 && !isSpousePre65 ? true: false): (!isPre65 ? true : false);
    var premiumsObj = this.client.clientProfile.Premiums || [];
    console.log('premiumsObj', premiumsObj);
    let partB = premiumsObj.MedicarePartB && this.medicareCoverage.premiumType == 'Traditional Medicare' ? 'Part B': '';
    let partD = premiumsObj.MedicarePartD && this.medicareCoverage.premiumType == 'Traditional Medicare' ? 'Part D': '';
    let supplementalInsurance = premiumsObj.SupplimentalInsurance && this.medicareCoverage.premiumType == 'Traditional Medicare' ? 'Medigap ' + this.client.clientProfile.SelfSupplementalPlan: '';
    let medicareAdvantageHMO = premiumsObj.MedicareAdvantageHMO && this.medicareCoverage.premiumType == 'Medicare Advantage HMO (w/Rx)' ? 'Med. Adv. HMO (w/Rx)': '';
    let medicareAdvantagePPO = premiumsObj.MedicareAdvantagePPO && this.medicareCoverage.premiumType == 'Medicare Advantage PPO (w/Rx)' ? 'Med. Adv. PPO (w/Rx)': '';
    let dentalInsurnace = premiumsObj.DentalInsurance ? 'Dental': '';

    var oOOPsObj = JSON.parse(this.client.clientProfile.OOPCosts) || [];
    let hospDoc = oOOPsObj.HospitalAndTest ? 'Hosp/Doc/Tests': '';
    let rX = oOOPsObj.PrescriptionDrugs ? 'Rx': '';
    let hearingAndVisionCosts = oOOPsObj.HearingAndVisionCosts ? 'Hearing/Vision': '';
    let dentalCosts = oOOPsObj.DentalCosts ? 'Dental':'';

    console.log('this.client.clientProfile.SpousePremiums', this.client.clientProfile.SpousePremiums)
    var spousePremiumsObj = this.client.clientProfile.SpousePremiums || [];
    let spousePartB = spousePremiumsObj.SpouseMedicarePartB && this.medicareCoverage.spousePremiumType == 'Traditional Medicare' ? 'Part B': '';
    let spousePartD = spousePremiumsObj.SpouseMedicarePartD && this.medicareCoverage.spousePremiumType == 'Traditional Medicare' ? 'Part D': '';
    let spouseSupplementalInsurance = spousePremiumsObj.SpouseSupplimentalInsurance && this.medicareCoverage.spousePremiumType == 'Traditional Medicare' ? 'Medigap ' + this.client.clientProfile.SpouseSupplementalPlan: '';
    let spouseMedicareAdvantageHMO = spousePremiumsObj.SpouseMedicareAdvantageHMO && this.medicareCoverage.spousePremiumType == 'Medicare Advantage HMO (w/Rx)' ? 'Med. Adv. HMO (w/Rx)': '';
    let spouseMedicareAdvantagePPO = spousePremiumsObj.SpouseMedicareAdvantagePPO && this.medicareCoverage.spousePremiumType == 'Medicare Advantage PPO (w/Rx)' ? 'Med. Adv. PPO (w/Rx)': '';
    let spouseDentalInsurnace = spousePremiumsObj.SpouseDentalInsurance ? 'Dental': '';

    var spouseOOOPsObj = JSON.parse(this.client.clientProfile.SpouseOOPCosts) || [];
    let spouseHospDoc = spouseOOOPsObj.SpouseHospitalAndTest ? 'Hosp/Doc/Tests': '';
    let spouseRX = spouseOOOPsObj.SpousePrescriptionDrugs ? 'Rx': '';
    let spouseHearingAndVisionCosts = spouseOOOPsObj.SpouseHearingAndVisionCosts ? 'Hearing/Vision': '';
    let spouseDentalCosts = spouseOOOPsObj.SpouseDentalCosts ? 'Dental':'';

    let premiums = partB + (partB ? ', ':'') + partD +(partD ? ', ':'') + supplementalInsurance + (supplementalInsurance ? ', ':'') + medicareAdvantageHMO + (medicareAdvantageHMO ? ', ':'') + medicareAdvantagePPO + (medicareAdvantagePPO ? ', ':'') + dentalInsurnace + (dentalInsurnace ? ', ':'');
    // let premiums = (partB ? ', '+ partB + ' ' :'') +(partD ? ', '+ partD + ' ' :'') + (supplementalInsurance ? ', '+ supplementalInsurance + ' ' :'') + (medicareAdvantageHMO ? ', '+ medicareAdvantageHMO + ' ' :'') + (medicareAdvantagePPO ? ', '+ medicareAdvantagePPO + ' ' :'') + (dentalInsurnace ? ', '+ dentalInsurnace + ' ' :'');
    premiums = premiums ? premiums : '--';
    let oOPS = hospDoc + (hospDoc ? ', ':'') + rX +(rX ? ', ':'') + hearingAndVisionCosts + (hearingAndVisionCosts ? ', ':'') + dentalCosts + (dentalCosts ? ', ':'');
    // let oOPS = (hospDoc ? ', '+ hospDoc + ' ' :'') +(rX ? ', '+ rX + ' ' :'') + (hearingAndVisionCosts ? ', '+ hearingAndVisionCosts + ' ' :'') + (dentalCosts ? ', '+ dentalCosts + ' ' :'');
    
    oOPS = oOPS ? oOPS : '--';
    let spousePremiums = spousePartB + (spousePartB ? ', ':'') + spousePartD +(spousePartD ? ', ':'') + spouseSupplementalInsurance + (spouseSupplementalInsurance ? ', ':'') + spouseMedicareAdvantageHMO + (spouseMedicareAdvantageHMO ? ', ':'') + spouseMedicareAdvantagePPO + (spouseMedicareAdvantagePPO ? ', ':'') + spouseDentalInsurnace + (spouseDentalInsurnace ? ', ':'');
    // let spousePremiums = (spousePartB ? ', '+ spousePartB + ' ' :'') +(spousePartD ? ', '+ spousePartD + ' ' :'') + (spouseSupplementalInsurance ? ', '+ spouseSupplementalInsurance + ' ' :'') + (spouseMedicareAdvantageHMO ? ', '+ spouseMedicareAdvantageHMO + ' ' :'') + (spouseMedicareAdvantagePPO ? ', '+ spouseMedicareAdvantagePPO + ' ' :'') + (spouseDentalInsurnace ? ', '+ spouseDentalInsurnace + ' ' :'');
    spousePremiums = spousePremiums ? spousePremiums : '--';
    let spouseOOPS = spouseHospDoc + (spouseHospDoc ? ', ':'') + spouseRX +(spouseRX ? ', ':'') + spouseHearingAndVisionCosts + (spouseHearingAndVisionCosts ? ', ':'') + spouseDentalCosts + (spouseDentalCosts ? ', ':'');
    // let spouseOOPS = (spouseHospDoc ? ', '+ spouseHospDoc + ' ' :'') +(spouseRX ? ', '+ spouseRX + ' ' :'') + (spouseHearingAndVisionCosts ? ', '+ spouseHearingAndVisionCosts + ' ' :'') + (spouseDentalCosts ? ', '+ spouseDentalCosts + ' ' :'');
    spouseOOPS = spouseOOPS ? spouseOOPS : '--';
    console.log('premiums', premiums);
    console.log('spousePremiums', spousePremiums);
    console.log('oOOPsObj', oOOPsObj);
    console.log('spouseOOPS', spouseOOPS);
    this.medicareCoverage.isShowSpouse = (premiums == spousePremiums && oOPS == spouseOOPS) || (this.isMarried == 'false') ? false : true;
    console.log('isPre65Disable', isPre65Disable);
    this.navHealthCareCards = [
      { title: 'Pre-65 Coverage', field1Label: 'Private Healthcare Coverage', field1Value: isPrivateHealthCareCoverage, 
        spouseField1Label: 'Private Healthcare Coverage', spouseField1Value: isSpousePrivateHealthCareCoverage, 
        field3Label:'Coverage Type', field3Value: this.pre65Coverage.coverageType ? this.pre65Coverage.coverageType:'--', 
        spouseField3Label:'Coverage Type', spouseField3Value: this.pre65Coverage.spouseCoverageType ? this.pre65Coverage.spouseCoverageType:'',  
        'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, 
        isDisabled: this.medicareCoverage.isDisabled || isPre65Disable, 
        isShowSpouse: this.pre65Coverage.isShowSpouse, cardHeight: this.pre65Coverage.cardHeight , sourceCard: 'hcCard'},
      // { title: 'Medicare Coverage', 
      //   field1Label: 'Premium Type', field1Value: this.medicareCoverage.premiumType ? this.medicareCoverage.premiumType :'--', 
      //   spouseField1Label: 'Premium Type', spouseField1Value: this.medicareCoverage.spousePremiumType ? this.medicareCoverage.spousePremiumType:'--', 
      //   field3Label:'Coverage Type', field3Value: this.medicareCoverage.coverageChoices ? this.medicareCoverage.coverageChoices:'--', 
      //   spouseField3Label:'Coverage Type', spouseField3Value: this.medicareCoverage.spouseCoverageChoices ? this.medicareCoverage.spouseCoverageChoices:'--', 
      //   'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, isDisabled: this.medicareCoverage.isDisabled, isShowSpouse: this.medicareCoverage.isShowSpouse, cardHeight:this.medicareCoverage.cardHeight , sourceCard: 'hcCard'},
      { title: 'Medicare Coverage', 
        field1Label: 'Premiums', field1Value: premiums, 
        spouseField1Label: 'Premiums', spouseField1Value: spousePremiums, 
        field3Label:'OOPs', field3Value: oOPS, 
        spouseField3Label:'OOPs', spouseField3Value: spouseOOPS, 
        'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, isDisabled: this.medicareCoverage.isDisabled, isShowSpouse: this.medicareCoverage.isShowSpouse, cardHeight:this.medicareCoverage.cardHeight , sourceCard: 'hcCard'},
      { title: 'Income', field1Label: (this.client.clientProfile.Bracket) ? 'MAGI Bracket' 
      : this.client.clientProfile.HouseholdYearOneIncome 
      ? 'Household Income Year One' : (this.SocialSecurity.isShowSpouse) ? 'Household Income' : 'Current Income', 
      field1Value: (this.client.clientProfile.Bracket) ? this.income.mAGIBracket ? this.income.mAGIBracket : '--' 
      : this.client.clientProfile.HouseholdYearOneIncome 
      ? Utils.formatToCurrency(this.client.clientProfile.HouseholdYearOneIncome) 
      : (this.client.clientProfile.CurrentIncome) ? Utils.formatToCurrency(parseInt(this.client.clientProfile.CurrentIncome) + (this.SocialSecurity.isShowSpouse ? (this.client.clientProfile.Spouses[0].currentIncome) ? parseInt(this.client.clientProfile.Spouses[0].currentIncome) : 0 : 0)) : '--', 
      'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, 
      isDisabled: this.medicareCoverage.isDisabled, cardHeight:this.pre65Coverage.cardHeight, sourceCard: 'hcCard'},
    ];
    if (this.isMarried == 'true') {
      console.log('here i am');
      console.log('this.LTCMetroArea.clientMetroArea', this.LTCMetroArea.clientMetroArea)
      this.LTCMetroArea.isDisabled = (this.LTCMetroArea.clientRetirementLocation && this.LTCMetroArea.clientMetroArea != '--' && this.LTCMetroArea.spouseRetirementLocation && this.LTCMetroArea.spouseMetroArea != '--') || this.LTCMetroArea.clientRetirementLocation == 'NA' && this.LTCMetroArea.spouseRetirementLocation == 'NA' || this.LTCMetroArea.clientRetirementLocation == 'NA' && this.LTCMetroArea.spouseRetirementLocation && this.LTCMetroArea.spouseMetroArea != '--' || this.LTCMetroArea.spouseRetirementLocation == 'NA' && this.LTCMetroArea.clientRetirementLocation && this.LTCMetroArea.clientMetroArea != '--'? false: true;
      console.log('this.LTCMetroArea.isDisabled', this.LTCMetroArea.isDisabled)
    } else {
      this.LTCMetroArea.isDisabled = (this.LTCMetroArea.clientRetirementLocation && this.LTCMetroArea.clientMetroArea != '--') || this.LTCMetroArea.clientRetirementLocation == 'NA' ? false: true;
    }

    this.isLongTermCareEdit = !this.LTCMetroArea.isDisabled;

    this.isCombinedEdit = (this.isHealthCareEdit && this.isLongTermCareEdit) ? true : false;

    this.ltcCards = [
      { title: 'Metro Area', field1Label: 'Location', field1Value: this.LTCMetroArea.clientRetirementLocation?this.LTCMetroArea.clientRetirementLocation:'--', 
      spouseField1Label: 'Location', spouseField1Value: this.LTCMetroArea.spouseRetirementLocation ? this.LTCMetroArea.spouseRetirementLocation:'--', 
      field3Label:'Metro Area', 
      field3Value: this.LTCMetroArea.clientMetroArea, 
      spouseField3Label:'Metro Area', 
      spouseField3Value: this.LTCMetroArea.spouseMetroArea,  'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, 
      isDisabled: this.LTCMetroArea.isDisabled, isShowSpouse: this.LTCMetroArea.isShowSpouse, cardHeight:this.LTCMetroArea.cardHeight, sourceCard: 'ltcCard'},
     
    ];

    this.comboCards = [
      { title: 'Pre-65 Coverage', field1Label: 'Private Healthcare Coverage', field1Value: isPrivateHealthCareCoverage,  
        spouseField1Label: 'Private Healthcare Coverage', spouseField1Value: isSpousePrivateHealthCareCoverage,
        field3Label:'Coverage Type', field3Value: this.pre65Coverage.coverageType ? this.pre65Coverage.coverageType:'--', 
        spouseField3Label:'Coverage Type', spouseField3Value: this.pre65Coverage.spouseCoverageType ? this.pre65Coverage.spouseCoverageType:'',  
        'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, 
        isDisabled: this.medicareCoverage.isDisabled || isPre65Disable, 
        isShowSpouse: this.pre65Coverage.isShowSpouse, cardHeight: this.pre65Coverage.cardHeight, sourceCard: 'comboCard' },
      // { title: 'Medicare Coverage', field1Label: 'Premium Type', field1Value: this.medicareCoverage.premiumType ? this.medicareCoverage.premiumType :'--',
      //   spouseField1Label: 'Premium Type', spouseField1Value: this.medicareCoverage.spousePremiumType?this.medicareCoverage.spousePremiumType:'--', 
      //   field3Label:'Coverage Type', field3Value: this.medicareCoverage.coverageChoices ? this.medicareCoverage.coverageChoices:'--', 
      //   spouseField3Label:'Coverage Type', spouseField3Value: this.medicareCoverage.spouseCoverageChoices ? this.medicareCoverage.spouseCoverageChoices:'--', 
      //   'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, 
      //   isDisabled: this.medicareCoverage.isDisabled, isShowSpouse: this.medicareCoverage.isShowSpouse, cardHeight:this.medicareCoverage.cardHeight, sourceCard: 'comboCard' },
      { title: 'Medicare Coverage', 
        field1Label: 'Premiums', field1Value: premiums, 
        spouseField1Label: 'Premiums', spouseField1Value: spousePremiums, 
        field3Label:'OOPs', field3Value: oOPS, 
        spouseField3Label:'OOPs', spouseField3Value: spouseOOPS, 
        'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, isDisabled: this.medicareCoverage.isDisabled, isShowSpouse: this.medicareCoverage.isShowSpouse, cardHeight:this.medicareCoverage.cardHeight , sourceCard: 'comboCard' },
      
        { title: 'Income', field1Label: (this.client.clientProfile.Bracket) ? 'MAGI Bracket' 
          : this.client.clientProfile.HouseholdYearOneIncome 
          ? 'Household Income Year One' : (this.SocialSecurity.isShowSpouse) ? 'Household Income' : 'Current Income', 
          field1Value: (this.client.clientProfile.Bracket) ? this.income.mAGIBracket ? this.income.mAGIBracket : '--' 
          : this.client.clientProfile.HouseholdYearOneIncome 
          ? Utils.formatToCurrency(this.client.clientProfile.HouseholdYearOneIncome) 
          : (this.client.clientProfile.CurrentIncome) ? Utils.formatToCurrency(parseInt(this.client.clientProfile.CurrentIncome) + (this.SocialSecurity.isShowSpouse ? (this.client.clientProfile.Spouses[0].currentIncome) ? parseInt(this.client.clientProfile.Spouses[0].currentIncome) : 0 : 0)) : '--', 
          'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, 
          isDisabled: this.medicareCoverage.isDisabled, cardHeight:this.pre65Coverage.cardHeight, sourceCard: 'comboCard'},

      { title: 'Metro Area', 
      field1Label: 'Location', field1Value: this.LTCMetroArea.clientRetirementLocation?this.LTCMetroArea.clientRetirementLocation:'--', 
      spouseField1Label: 'Location', spouseField1Value: this.LTCMetroArea.spouseRetirementLocation ? this.LTCMetroArea.spouseRetirementLocation:'--', field3Label:'Metro Area', field3Value: this.LTCMetroArea.clientMetroArea ? this.LTCMetroArea.clientMetroArea:'--', spouseField3Label:'Metro Area', spouseField3Value: this.LTCMetroArea.spouseMetroArea ? this.LTCMetroArea.spouseMetroArea :'--',  'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, isDisabled: this.LTCMetroArea.isDisabled, isShowSpouse: this.LTCMetroArea.isShowSpouse, cardHeight:this.LTCMetroArea.cardHeight, sourceCard: 'comboCard'},
    ];
     
    this.mmtCards = [
      //{ title: 'Income', field1Label: 'Annual Income', field1Value: this.client.clientProfile.CurrentIncome ? this.client.clientProfile.CurrentIncome:'--', field3Label:'Metro Area', field3Value: this.LTCMetroArea.clientMetroArea ? this.LTCMetroArea.clientMetroArea: '--',  'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, isDisabled: true},
      //{ title: 'MAGI', field1Label: 'Adjust MAGI', field1Value: this.client.clientProfile.MAGIPercentIncome ? this.client.clientProfile.MAGIPercentIncome +' %':'--', field3Label:'Metro Area', field3Value: this.LTCMetroArea.clientMetroArea ? this.LTCMetroArea.clientMetroArea: '--',  'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, isDisabled: true},
      { 
        //title: 'Income', field1Label: 'MAGI Bracket', field1Value: this.income.mAGIBracket ? this.income.mAGIBracket:'--', 
        title: 'Income', field1Label: (this.client.clientProfile.Bracket) ? 'MAGI Bracket' : this.client.clientProfile.HouseholdYearOneIncome ? 'Household Income Year One' : (this.SocialSecurity.isShowSpouse) 
        ? 'Household Income' : 'Current Income', field1Value: (this.client.clientProfile.Bracket) ? this.income.mAGIBracket ? this.income.mAGIBracket : '--' 
        : this.client.clientProfile.HouseholdYearOneIncome ? Utils.formatToCurrency(this.client.clientProfile.HouseholdYearOneIncome) 
        : (this.client.clientProfile.CurrentIncome) ? Utils.formatToCurrency(parseInt(this.client.clientProfile.CurrentIncome) + (this.SocialSecurity.isShowSpouse ? (this.client.clientProfile.Spouses[0].currentIncome) ? parseInt(this.client.clientProfile.Spouses[0].currentIncome) : 0 : 0)) : '--', 
      'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, isDisabled: this.pre65Coverage.isDisabled, cardHeight:this.pre65Coverage.cardHeight, sourceCard: 'mmtCard'}
    ];
    let showSpouseSpouses = this.client.clientProfile.Spouses[0].spousesSpouse && this.client.clientProfile.IsLegalSpouse == 0 ? (this.client.clientProfile.Spouses[0].spousesSpouse.length > 0 ? 'Yes' : 'No'): 'No';
    let isLifeExpectamcyLowerthanSixtyTwo = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? ((this.client.clientProfile.LifeExpectancy < 62 || this.client.clientProfile.Spouses[0].LifeExpectancy < 62) ? true: false): (this.client.clientProfile.LifeExpectancy < 62 ? true: false);
    let isDisable = isLifeExpectamcyLowerthanSixtyTwo ? true : this.client.clientProfile.CurrentIncome == null ? true : this.SocialSecurity.isDisable;
    let isClientSixtyPlusAtMarriage = false;
    let isSixtyPlusPreviousMarraige = false;

    if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && this.client.clientProfile.Spouses[0].hasOwnProperty('anniversary') && this.client.clientProfile.IsLegalSpouse) {
      let anniversayDate = new Date(this.client.clientProfile.Spouses[0].anniversary);
      isClientSixtyPlusAtMarriage = this.calculateAgeAtMarriage(this.client.client.DOB, anniversayDate) >= 60 ? true : false;
      isSixtyPlusPreviousMarraige = this.client.clientProfile.Spouses.length > 1 && isClientSixtyPlusAtMarriage ? true: false;
    }

    if(this.client.clientProfile.PIA != null || (this.client.clientProfile.MonthlyBenefitAmount != null && this.client.clientProfile.DateOfClaimYear != null)) {    
     var isAnyChildDisabled = false;
      var isAnyChildUnder18 = false;
      var childrenUnder18Count = 0;
      if (this.client.clientProfile.Children && this.client.clientProfile.Children != '[]') {
        if (typeof this.client.clientProfile.Children === 'string') {
          var childrenArr = JSON.parse(this.client.clientProfile.Children);
          const disabledList = childrenArr.filter(c => c.isDisabled);
          if (disabledList.length > 0) {
            isAnyChildDisabled = true;
          }
          const under18List = childrenArr.filter(c => c.DependentChildAge < 18);
          if (under18List.length > 0) {
            isAnyChildUnder18 = true;
            childrenUnder18Count = under18List.length;
          }
        }
      }
      

      this.ssCards = [
        //{ title: 'Income', field1Label: 'Annual Income', field1Value: this.client.clientProfile.CurrentIncome ? this.client.clientProfile.CurrentIncome:'--', field3Label:'Metro Area', field3Value: this.LTCMetroArea.clientMetroArea ? this.LTCMetroArea.clientMetroArea: '--',  'isCoverageFilled': false, isEditClient: true, showQuestionnaire: true, isDisabled: this.SocialSecurity.isDisable, isShowSpouse: this.SocialSecurity.isShowSpouse,  sourceCard: 'ssCard'},
        //{ title: 'Income', field1Label: 'MAGI Bracket', field1Value: this.income.mAGIBracket ? this.income.mAGIBracket:'--', 'isCoverageFilled': false, isEditClient: true, showQuestionnaire: false, isDisabled: this.pre65Coverage.isDisabled, cardHeight:this.pre65Coverage.cardHeight, sourceCard: 'ssCard'},
        { title: 'Income', field1Label: this.client.clientProfile.HouseholdYearOneIncome ? 'Household Income Year One':(this.SocialSecurity.isShowSpouse) 
        ? 'Household Income' : 'Current Income', field1Value: this.client.clientProfile.HouseholdYearOneIncome ? Utils.formatToCurrency(this.client.clientProfile.HouseholdYearOneIncome) 
        : (this.client.clientProfile.CurrentIncome) ? Utils.formatToCurrency(parseInt(this.client.clientProfile.CurrentIncome) + (this.SocialSecurity.isShowSpouse ? (this.client.clientProfile.Spouses[0].currentIncome) ? parseInt(this.client.clientProfile.Spouses[0].currentIncome) : 0 : 0)) : '--', 
          field3Label:(this.SocialSecurity.isShowSpouse) ? (((this.client.clientProfile.SelfKnownBenefitClaiming && this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming) ? 'Benefit if Claimed Today' 
          : ((!this.client.clientProfile.SelfKnownBenefitClaiming && this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming) || (this.client.clientProfile.SelfKnownBenefitClaiming && !this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming))
          ? (this.client.clientProfile.SelfKnownBenefitClaiming ? 'Benefit if Claimed Today' : (this.client.clientProfile.MonthlyBenefitAmount && this.client.clientProfile.DateOfClaimYear) ? 'Current Gross Benefit' :'PIA') + '/' + (this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming ? 'Benefit if Claimed Today' : (this.client.clientProfile.Spouses[0].monthlyBenefits && this.client.clientProfile.Spouses[0].dateOfClaimYear) 
          ? 'Current Gross Benefit' : 'PIA') : 'PIA')) 
          : (this.client.clientProfile.SelfKnownBenefitClaiming) ? 'Benefit if Claimed Today' : (this.client.clientProfile.MonthlyBenefitAmount && this.client.clientProfile.DateOfClaimYear) ? 'Current Gross Benefit' : 'PIA', 
          field3Value: (this.SocialSecurity.isShowSpouse) ? this.client.client.FirstName + ' ' + Utils.formatToCurrency((this.client.clientProfile.PIA) 
          ? this.client.clientProfile.PIA : (this.client.clientProfile.SelfKnownBenefitClaiming ? this.client.clientProfile.SelfKnownBenefitClaiming : this.client.clientProfile.MonthlyBenefitAmount)) + '; ' + this.client.clientProfile.Spouses[0].firstName + ' ' + Utils.formatToCurrency((this.client.clientProfile.Spouses[0].pia) 
          ? this.client.clientProfile.Spouses[0].pia : (this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming) ? this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming : (this.client.clientProfile.Spouses[0].monthlyBenefits) ? Utils.removeCurrencyFormatting(this.client.clientProfile.Spouses[0].monthlyBenefits) : 0) 
          : Utils.formatToCurrency((this.client.clientProfile.PIA) ? this.client.clientProfile.PIA : (this.client.clientProfile.SelfKnownBenefitClaiming ? this.client.clientProfile.SelfKnownBenefitClaiming || 0 : this.client.clientProfile.MonthlyBenefitAmount || 0)), 
          field4Label:'Collecting', field4Value: (this.SocialSecurity.isShowSpouse) ? 
          //(this.client.clientProfile.MonthlyBenefitAmount && this.client.clientProfile.Spouses[0].monthlyBenefits && this.client.clientProfile.Spouses[0].monthlyBenefits.length > 0) 
          (this.client.clientProfile.SelfAlreadyCollecting && this.client.clientProfile.SpouseAlreadyCollecting) 
          ? this.client.client.FirstName + ' & ' + this.client.clientProfile.Spouses[0].firstName 
          //: (this.client.clientProfile.Spouses[0].monthlyBenefits && this.client.clientProfile.Spouses[0].monthlyBenefits.length > 0) 
          : (this.client.clientProfile.SpouseAlreadyCollecting) 
          ? this.client.clientProfile.Spouses[0].firstName 
          //: (this.client.clientProfile.MonthlyBenefits && this.client.clientProfile.MonthlyBenefits.length > 0) 
          : (this.client.clientProfile.SelfAlreadyCollecting) 
          ? this.client.client.FirstName : '' 
          //: (this.client.clientProfile.MonthlyBenefits && this.client.clientProfile.MonthlyBenefits.length > 0) 
          : (this.client.clientProfile.SelfAlreadyCollecting) 
          ? this.client.client.FirstName : '', 'isCoverageFilled' : false, isEditClient: true, showQuestionnaire: true, isDisabled: isDisable, isShowSpouse: this.SocialSecurity.isShowSpouse, sourceCard: 'ssCard'},// cardHeight: this.pre65Coverage.cardHeight,
        { title: 'Retirement', 
        field1Label: 'Desired Claim Age', 
        field1Value: (this.SocialSecurity.isShowSpouse) ? ((!this.client.clientProfile.SelfAlreadyCollecting) ? this.client.client.FirstName + ' ' + this.SocialSecurity.clientAgeStart : "--") + '; ' + ((!this.client.clientProfile.SpouseAlreadyCollecting) ? this.client.clientProfile.Spouses[0].firstName + ' ' + this.SocialSecurity.spouseAgeStart : "--")
        : (this.SocialSecurity.clientAgeStart) ? this.SocialSecurity.clientAgeStart : '', 
          field3Label:'Work in Retirement', field3Value: (this.SocialSecurity.isShowSpouse) ? this.client.client.FirstName + ' ' + ((this.client.clientProfile.InRetFirstYearIncome) ? 'Yes' : 'No') + '; ' + this.client.clientProfile.Spouses[0].firstName + ' ' + ((this.client.clientProfile.Spouses[0].inRetFirstYearIncome) ? 'Yes' : 'No') : ((this.client.clientProfile.InRetFirstYearIncome) ? 'Yes' : 'No'), 
          field4Label:'Pension', field4Value: (this.SocialSecurity.isShowSpouse) ? this.client.client.FirstName + ' ' + ((this.client.clientProfile.Pension) ? 'Yes' : 'No') + '; ' + this.client.clientProfile.Spouses[0].firstName + ' ' + ((this.client.clientProfile.Spouses[0].annualPensionValue || this.client.clientProfile.Spouses[0].pension) ? 'Yes' : 'No') : (this.client.clientProfile.Pension) ? 'Yes' : 'No',  
          'isCoverageFilled': false, isEditClient: true, isAlreadyUpdate: this.SocialSecurity.isAlreadyUpdate, isDisabled: isDisable, isShowSpouse: this.SocialSecurity.isShowSpouse, sourceCard: 'ssCard'}, //cardHeight:this.pre65Coverage.cardHeight
        { title: 'Family', 
          field1Label: 'Previous Marriages', 
          field1Value: (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' || isSixtyPlusPreviousMarraige)? 'Yes' : 'No',
          // field1Value: (this.SocialSecurity.isShowSpouse) ? (this.client.client.FirstName + ' ' + ((this.client.clientProfile.Spouses.length > 1) ? (this.client.clientProfile.IsLegalSpouse == 0 ? 'Yes':'No') : 'No') + '; ' + this.client.clientProfile.Spouses[0].firstName + ' ' + showSpouseSpouses) : ((this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].maritalStatus != 'Single' || this.client.clientProfile.Spouses.length > 1 && this.client.clientProfile.Spouses[1].maritalStatus != 'Single') ? 'Yes' : 'No'), 
          
          //Dependent Children
          field3Label:'Dependent Children (Under 18)', 
          field3Value: ((this.client.clientProfile.Children && this.client.clientProfile.Children != "[]")) ? 
          childrenUnder18Count : '--', 
          //(this.SocialSecurity.isShowSpouse) ? 
          //(parseInt((this.client.clientProfile.Spouses[0].children) 
          //? this.client.clientProfile.Spouses[0].children.length : 0) + parseInt((this.client.clientProfile.Children && this.client.clientProfile.Children != "[]" && this.client.clientProfile.Children != "null") ? JSON.parse(this.client.clientProfile.Children).length : 0))
          //: parseInt((this.client.clientProfile.Children && this.client.clientProfile.Children != "[]" && this.client.clientProfile.Children != "null") ? JSON.parse(this.client.clientProfile.Children).length : 0)
          //: '--', 
          field4Label: 'Disabled Children',
          field4Value: isAnyChildDisabled ? 'Yes' : 'No',//((this.client.clientProfile.Children && this.client.clientProfile.Children != "[]")),
          'isCoverageFilled': false, isEditClient: true, isAlreadyUpdate: this.SocialSecurity.isAlreadyUpdate, isDisabled: isDisable, isShowSpouse: this.SocialSecurity.isShowSpouse, sourceCard: 'ssCard'}//cardHeight:this.pre65Coverage.cardHeight,
      ];
    } else {
      if(this.isSocialSecurityEdit){
        this.isSocialSecurityEdit = (this.ssCards.length > 0);
      }
    }
  }

  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
  
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }
  calculateAgeAtMarriage(birthdate, marriageDate) {
    birthdate = new Date(birthdate);
    marriageDate = new Date(marriageDate);
    var diffYear = marriageDate.getFullYear() - birthdate.getFullYear();
    return diffYear
  }

  navigateTo(page, direction){
    let hasRanMiniQuestionnaire = (this.client.clientProfile.CoverageType || this.client.clientProfile.ClientMetroArea || this.client.clientProfile.SSDesiredAgeYears || this.client.clientProfile.MonthlyBenefitAmount || this.client.clientProfile.PIA || this.client.clientProfile.CurrentIncome > 0) ? true : false;
    
    if(page == 'HC'){
      if(direction == 'quick'){
        this.router.navigate(['/clients/edit/healthcare/options/hcq']);
      } else if(direction == 'screen'){
        this.router.navigate(['/clients/edit/healthcare/options/hc']);
      } else if(direction == 'screen-rt'){
        this.router.navigate(['/clients/edit/healthcare/options/hcrt']);
      } else if(direction == 'editAll') {
        this.router.navigate(['/clients/edit/healthcare'], { state: { params: 'editAll' } });
      } else{
        //make this the HC questionnaire url
        this.router.navigate(['/clients/edit/healthcare'], { state: { params: 'empty' } });
        //this.router.navigate(['/reports/hc-questionnaire']);
      }
    }

    if(page == 'LTC'){
      if(direction == 'quick'){
        this.router.navigate(['/clients/edit/long-term-care/options/ltcq']);
      } else if(direction == 'screen'){
        this.router.navigate(['/clients/edit/long-term-care/options/ltc']);
      } else if(direction == 'screen-rt'){
        this.router.navigate(['/clients/edit/long-term-care/options/ltcrt']);
      } else if(direction == 'editAll') {
        //this.router.navigate(['/reports/ltc-questionnaire'], { state: { params: 'editAll' } });
        this.router.navigate(['/clients/edit/long-term-care'], { state: { params: 'editAll' } });
      } else {
        //make this the LTC questionnaire url
        this.router.navigate(['/clients/edit/long-term-care'], { state: { params: '' } });
        //this.router.navigate(['/reports/ltc-questionnaire']);
      }
      
    }

    if(page == 'COMB'){
      if(direction == 'quick'){
        this.router.navigate(['/clients/edit/combined/options/hcltc']);
      } else if(direction == 'screen'){
        //no on-screen right now for Combined
        this.router.navigate(['/clients/edit/combined/options/combined']);
      }else if(direction == 'editAll') {
        //this.router.navigate(['/reports/combined-questionnaire'], { state: { params: 'editAll' } });
        this.router.navigate(['/clients/edit/combined'], { state: { params: 'editAll' } });
      } else {
        //make this the LTC questionnaire url
        this.router.navigate(['/clients/edit/combined'], { state: { params: '' } });
      }
    }

    if(page == 'MMT'){
      if(!this.isMMTSectionDisabled){
        if(direction == 'quick'){
          //mmt has no quick report right now
          //this.router.navigate(['/reports/create/ltc']);
          this.router.navigate(['/clients/edit/medicare-means-testing/options/mmtq']);
        } else if(direction == 'screen'){
          //this.router.navigate(['/reports/create/mmtv2']);
          //clients/edit/medicare-means-testing/options/mmtv2
          this.router.navigate(['/clients/edit/medicare-means-testing/options/mmtv2']);

        } else if(direction == 'edit' || direction == 'new'){
          this.router.navigate(['/clients/edit/healthcare'], { state: { params: 'income' } });
        } else {
          if(!this.client.clientProfile.CurrentIncome && !this.client.clientProfile.HouseholdYearOneIncome){
            const dialogRef = this.dialog.open(MmtMessageComponent, {
              width: '600px',
              height: '400px',
              //data: { modalName: "", dataSource: "" }
            });    
          /*  dialogRef.afterClosed().subscribe(result => {       
              this.router.navigate(['/reports/create/mmt']);
            }); */
          } else {
            this.router.navigate(['/clients/edit/medicare-means-testing/options/mmtq']);
          }
        }
      } else {
        //display modal for MMT needing income
        const dialogRef = this.dialog.open(BasicQuestionComponent, {     
          data: { title: 'Notification!',
          btnNoTitle: 'Cancel',
          btnYesTitle: 'Continue',
          question: 'In order to run the <b>Medicare Means Testing Illustration</b>, please complete <br/>the "Calculate Projected Retirement Income" module in the Client Profile.'
        }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          //console.log('result', result);  
          if(result){
            //go to Income section of QQ
            this.router.navigate(['/clients/edit/healthcare'], { state: { params: 'income' } });
          }
        }); 
      }
    }

    if(page == 'SS'){
      console.log('this.client', this.client)
      let isLifeExpectamcyLowerthanSixtyTwo = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? ((this.client.clientProfile.LifeExpectancy < 62 || this.client.clientProfile.Spouses[0].LifeExpectancy < 62) ? true: false): (this.client.clientProfile.LifeExpectancy < 62 ? true: false);
      
      if (isLifeExpectamcyLowerthanSixtyTwo && hasRanMiniQuestionnaire) {
        if (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
          if (this.client.clientProfile.LifeExpectancy < 62 && this.client.clientProfile.Spouses[0].LifeExpectancy < 62) {
            const dialogRef = this.matDialog.open(MessageComponent, {     
              data: { title: 'Cannot Continue', message: 'Client and Spouse Life Expectancy is lower than Social Security eligibility. A report cannot currently be run. <br/> To modify Life Expectancy, open the Client Info Editor from the right side of the client hub page.' }
            });
          } else if (this.client.clientProfile.LifeExpectancy < 62) {
            const dialogRef = this.matDialog.open(MessageComponent, {     
              data: { title: 'Cannot Continue', message: 'Client Life Expectancy is lower than Social Security eligibility. A report cannot currently be run. <br/> To modify Life Expectancy, open the Client Info Editor on the right side of your screen.' }
            });
          } else {
            const dialogRef = this.matDialog.open(MessageComponent, {     
              data: { title: 'Cannot Continue', message: 'Spouse Life Expectancy is lower than Social Security eligibility. A report cannot currently be run. <br/> To modify Life Expectancy, open the Client Info Editor from the right side of the client hub page.' }
            });
          }
        } else {
          if (this.client.clientProfile.LifeExpectancy < 62) {
            const dialogRef = this.matDialog.open(MessageComponent, {     
              data: { title: 'Cannot Continue', message: 'Client Life Expectancy is lower than Social Security eligibility. A report cannot currently be run. <br/> To modify Life Expectancy, open the Client Info Editor on the right side of your screen.' }
            });
          } 
        }
      } else {
        if(direction == 'quick'){
          this.router.navigate(['/clients/edit/social-security/options/ssq']);
        } else if(direction == 'screen'){
          this.router.navigate(['/clients/edit/social-security/options/ss']);
        } else if(direction == 'editAll') {
          this.router.navigate(['/clients/edit/social-security'], { state: { params: 'editAll' } });
        } else {
          this.router.navigate(['/clients/edit/social-security'], { state: { params: '' } });
          // this.router.navigate(['/reports/ss-questionnaire'], { state: { params: 'edit' } });
        }
      }

    }
  }

  determineClaimAge(DOB, SSDesiredAge) {
    const fullDOB = new Date(DOB.toString());
    let birthYear = fullDOB.getFullYear();
    let claimYear;
    // let clientFRA = this.getFRA(birthYear);

    //claimYear = birthYear + clientFRA.age;
    claimYear = birthYear + Number(SSDesiredAge);
    return claimYear
  }

  getBirthdayFullYear(dob: Date){
    //const birthDate = new Date(dob);
    const startYear = new Date().getFullYear();

    var _monthOffset = 0;
    // If the person's DOB falls on the first day of the month, Soc.Sec. pretends they are an extra month older (as if born in the PREVIOUS month)
    if (dob.getDate() == 1)
    {
      _monthOffset = 1;
    }
    //return _monthOffset;
    // console.log('month day', dob.getDate());
    // console.log('month day offset', _monthOffset);


    var _yearOffset = 0;
    // If the person's DOB falls on New Year's Day, Soc.Sec. references factors and age thresholds according to the PREVIOUS year
    if ((dob.getMonth() == 0) && (_monthOffset == 1))
    {
      //(dbarksdale3) Updated behavior of this value
      //_yearOffset = -1;
      _yearOffset = 1;
    }
    //return _yearOffset;
    // console.log('month', dob.getMonth());
    // console.log('year offset', _yearOffset);


    return (startYear - this.getCurrentAgeByDOB(dob) - _yearOffset);
  }

  getCurrentAgeByDOB(birthday){
    var dob = new Date(birthday);
    const startYear = new Date();
    var CurrentAgeOffset = ((startYear.getMonth() + 1) < (dob.getMonth() + 1)) ? 1 : 0;
    console.log('getCurrentAgeByDOB', ((((startYear.getFullYear() - dob.getFullYear()) * 12) + (startYear.getMonth() + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
    return Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (startYear.getMonth() + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
  }

  getFRAv2(bday){
    // const startYear = new Date().getFullYear();
    const birthDate = new Date(bday);
    //var yearOfBirth = birthDate.getFullYear();
    var yearOfBirth = this.getBirthdayFullYear(birthDate);

    // var yearOfBirth = startYear - birthYear;
    // console.log('yearOfBirth',yearOfBirth);
    var fraMonths = 0;
    if(yearOfBirth <= 1954){
      if (yearOfBirth <= 1937) {
        fraMonths = 780;
      } else {
        if (yearOfBirth <=1942) {
          switch (yearOfBirth)
          {
            case 1938:
              fraMonths = 780+2;
              break;
            case 1939:
              fraMonths = 780 + 4;
              break;
            case 1940:
              fraMonths = 780 + 6;
              break;
            case 1941:
              fraMonths = 780 + 8;
              break;
            case 1942:
              fraMonths = 780 + 10;
              break;

          }
        } else {
          fraMonths = 792;
        }

      }
    } else if (yearOfBirth <=1961 && this.client.clientProfile.Spouses[0].maritalStatus === 'Widowed') {
      switch (yearOfBirth)
      {
        case 1955:
          fraMonths = 792 + 0;
          break;
        case 1956:
          fraMonths = 792 + 0;
          break;
        case 1957:
          fraMonths = 792 + 2;
          break;
        case 1958:
          fraMonths = 792 + 4;
          break;
        case 1959:
          fraMonths = 792 + 6;
          break;
        case 1960:
          fraMonths = 792 + 8;
          break;
        case 1961:
          fraMonths = 792 + 10;
          break;
      }
    } else if(yearOfBirth <= 1959){
      switch (yearOfBirth)
      {
        case 1955:
          fraMonths = 792 + 2;
          break;
        case 1956:
          fraMonths = 792 + 4;
          break;
        case 1957:
          fraMonths = 792 + 6;
          break;
        case 1958:
          fraMonths = 792 + 8;
          break;
        case 1959:
          fraMonths = 792 + 10;
          break;
      }
    } else {
      fraMonths = 804;
    }

    // console.log('fraMonths', fraMonths);
    var fra = fraMonths / 12;
    // console.log('fra', fra);
    // console.log('framonthtest', )

    let FRA = {
      age: 0,
      month: 0,
    }
    FRA.age = Math.floor(fra);
    //console.log('log FRA', fra%12)
    //this.getBirthdayMonth(bday)
    FRA.month = fraMonths % 12;

    // console.log('returned FRA', FRA);
    return FRA
  }

  getFRA(bday) {
    let yearOfBirth = bday;
    let FRA = {
      age: 0,
      month: 0,
    }

    if (yearOfBirth <= 1937) {
      FRA.age = 65;
      FRA.month = 0;
    } else if (yearOfBirth === 1938) {
      FRA.age = 65;
      FRA.month = 2;
    } else if (yearOfBirth === 1939) {
      FRA.age = 65;
      FRA.month = 4;
    } else if (yearOfBirth === 1940) {
      FRA.age = 65;
      FRA.month = 6;
    } else if (yearOfBirth === 1941) {
      FRA.age = 65;
      FRA.month = 8;
    } else if (yearOfBirth === 1942) {
      FRA.age = 65;
      FRA.month = 10;
    } else if (yearOfBirth >= 1943 && yearOfBirth <= 1954) {
      FRA.age = 66;
      FRA.month = 0;
    } else if (yearOfBirth === 1955) {
      FRA.age = 66;
      FRA.month = 2;
    } else if (yearOfBirth === 1956) {
      FRA.age = 66;
      FRA.month = 4;
    } else if (yearOfBirth === 1957) {
      FRA.age = 66;
      FRA.month = 6;
    } else if (yearOfBirth === 1958) {
      FRA.age = 66;
      FRA.month = 8;
    } else if (yearOfBirth === 1959) {
      FRA.age = 66;
      FRA.month = 10;
    } else if (yearOfBirth >= 1960) {
      FRA.age = 67;
      FRA.month = 0;
    }

    return FRA;
  }



  getReports() {
    this.isLoadingReport = false;
    let listHCReportData: reportData[] = [];
    let listLTCReportData: reportData[] = [];
    let listCombinedReportData: reportData[] = [];
    let listMMTReportData: reportData[] = [];
    let listSSReportData: reportData[] = [];
    this.globalService.getClientReportsData(this.clientID)
        .subscribe(
            reports => {
              // var allReports = [];

              // var reportID = report.r.ReportID;
              // var advisorID = report.r.AdvisorID;
              // var clientID = report.r.ClientID;
              // var orgID = report.r.CompanyCode;
              // var reportTypeID = report.r.ReportTypeID;

              // console.log(reports);

              for (var type in reports) {
                reports[type].forEach((report) => {
                  let createdBy = this.advisorFirstName + ' '+ this.advisorLastName;
                  let clientFirstName = report.c.FirstName;
                  let clientLastName = report.c.LastName;

                  if (report.r.ClientID == this.clientID) {
                    if (report.hc) {
                      let data: reportData = {
                        type: report.r.ReportTypeID == 3 ? 'Healthcare Illustration' + ((this.globalService.featQuickReports) ? ' - Full' : '') : (report.r.ReportTypeID == 9 ?'Healthcare Illustration - Quick': ''),
                        createdBy: createdBy,
                        createdOn: report.r.Created_Date,
                        action: {reportID: report.r.ReportID,advisorID: report.r.AdvisorID,clientID: report.r.ClientID,orgID: report.r.CompanyCode,reportTypeID: report.r.ReportTypeID,clientFirstName: clientFirstName,clientLastName: clientLastName},
                        reportID: report.r.ReportID,
                        advisorID: report.r.AdvisorID,
                        clientID: report.r.ClientID,
                        orgID: report.r.CompanyCode,
                        reportTypeID: report.r.ReportTypeID,
                        clientFirstName: clientFirstName,
                        clientLastName: clientLastName
                      }

                      listHCReportData.push(data);
                    }
                    if (report.ltc) {
                      let data: reportData = {
                        type: report.r.ReportTypeID == 4 ? 'Long Term Care Illustration' + ((this.globalService.featQuickReports) ? ' - Full' : '') : (report.r.ReportTypeID == 10 ?'Long Term Care Illustration - Quick':''), 
                        createdBy: createdBy,
                        createdOn: report.r.Created_Date,
                        action: {reportID: report.r.ReportID,advisorID: report.r.AdvisorID,clientID: report.r.ClientID,orgID: report.r.CompanyCode,reportTypeID: report.r.ReportTypeID,clientFirstName: clientFirstName,clientLastName: clientLastName},
                        reportID: report.r.ReportID,
                        advisorID: report.r.AdvisorID,
                        clientID: report.r.ClientID,
                        orgID: report.r.CompanyCode,
                        reportTypeID: report.r.ReportTypeID,
                        clientFirstName: clientFirstName,
                        clientLastName: clientLastName
                      }

                      listLTCReportData.push(data);
                    }
                    if (report.mmt) {
                      let data: reportData = {
                        type: report.r.ReportTypeID == 2 ? 'Medicare Means Testing' + ((this.globalService.featQuickReports) ? ' - Full' : '') : (report.r.ReportTypeID == 12 ?'Medicare Means Testing - Quick':''),
                        createdBy: createdBy,
                        createdOn: report.r.Created_Date,
                        action: {reportID: report.r.ReportID,advisorID: report.r.AdvisorID,clientID: report.r.ClientID,orgID: report.r.CompanyCode,reportTypeID: report.r.ReportTypeID,clientFirstName: clientFirstName,clientLastName: clientLastName},
                        reportID: report.r.ReportID,
                        advisorID: report.r.AdvisorID,
                        clientID: report.r.ClientID,
                        orgID: report.r.CompanyCode,
                        reportTypeID: report.r.ReportTypeID,
                        clientFirstName: clientFirstName,
                        clientLastName: clientLastName
                      }

                      listMMTReportData.push(data);
                    }
                    if (report.ss) {
                      let data: reportData = {
                        type: report.r.ReportTypeID == 1 ? 'Social Security' + ((this.globalService.featQuickReports) ? ' - Full' : '') : (report.r.ReportTypeID == 11 ?'Social Security - Quick':''),
                        createdBy: createdBy,
                        createdOn: report.r.Created_Date,
                        action: {reportID: report.r.ReportID,advisorID: report.r.AdvisorID,clientID: report.r.ClientID,orgID: report.r.CompanyCode,reportTypeID: report.r.ReportTypeID,clientFirstName: clientFirstName,clientLastName: clientLastName},
                        reportID: report.r.ReportID,
                        advisorID: report.r.AdvisorID,
                        clientID: report.r.ClientID,
                        orgID: report.r.CompanyCode,
                        reportTypeID: report.r.ReportTypeID,
                        clientFirstName: clientFirstName,
                        clientLastName: clientLastName
                      }

                      listSSReportData.push(data);
                    }
                    if (report.comb) {
                      let data: reportData = {
                        type: report.r.ReportTypeID == 13 ? 'Combined Health/Long Term Care - Quick' : 'Combined Health/Long Term Care' + ((this.globalService.featQuickReports) ? ' - Full' : ''),
                        createdBy: createdBy,
                        createdOn: report.r.Created_Date,
                        action: {reportID: report.r.ReportID,advisorID: report.r.AdvisorID,clientID: report.r.ClientID,orgID: report.r.CompanyCode,reportTypeID: report.r.ReportTypeID,clientFirstName: clientFirstName,clientLastName: clientLastName},
                        reportID: report.r.ReportID,
                        advisorID: report.r.AdvisorID,
                        clientID: report.r.ClientID,
                        orgID: report.r.CompanyCode,
                        reportTypeID: report.r.ReportTypeID,
                        clientFirstName: clientFirstName,
                        clientLastName: clientLastName
                      }

                      listCombinedReportData.push(data);
                    }
                  }
                   
                });
              }
              listHCReportData.reverse();
              listLTCReportData.reverse();
              listMMTReportData.reverse();
              listSSReportData.reverse();
              listCombinedReportData.reverse();
              this.dataSourceHCReport = new MatTableDataSource(listHCReportData);
              this.cdr.detectChanges();
              if (this.pageSize && this.paginator) {
                this.paginator.pageSize = this.pageSize;
              }
              this.dataSourceHCReport.paginator = this.paginator;
              this.dataSourceHCReport.sort = this.sort;

              this.dataSourceLTCReport = new MatTableDataSource(listLTCReportData);
              if (this.pageSize && this.paginatorLTC) {
                this.paginatorLTC.pageSize = this.pageSize;
              }
              // this.cdr.detectChanges();
              this.dataSourceLTCReport.paginator = this.paginatorLTC;
              this.dataSourceLTCReport.sort = this.sortLTC;

              this.dataSourceMMTReport = new MatTableDataSource(listMMTReportData);
              if (this.pageSize && this.paginatorMMT) {
                this.paginatorMMT.pageSize = this.pageSize;
              }
              this.dataSourceMMTReport.paginator = this.paginatorMMT;
              this.dataSourceMMTReport.sort = this.sortMMT;

              this.dataSourceSSReport = new MatTableDataSource(listSSReportData);
              if (this.pageSize && this.paginatorSS) {
                this.paginatorSS.pageSize = this.pageSize;
              }
              this.dataSourceSSReport.paginator = this.paginatorSS;
              this.dataSourceSSReport.sort = this.sortSS;

              this.dataSourceCombinedReport = new MatTableDataSource(listCombinedReportData);
              if (this.pageSize && this.paginatorComb) {
                this.paginatorComb.pageSize = this.pageSize;
              }
              // this.cdr.detectChanges();
              this.dataSourceCombinedReport.paginator = this.paginatorComb;
              this.dataSourceCombinedReport.sort = this.sortComb;
                   
              this.isLoadingReport = true;
              


              
              // this.setPage(1);
            },
            error => {
              this.error = <any>error
            });
  }


  openPDF(row){

        console.log('data from row PDF', row);
        this.loadingService.isLoading(true);

        var reportID = row.reportID;
        var advisorID =row.advisorID;
        var clientID = row.clientID;
        var orgID = row.orgID;
        var reportTypeID = row.reportTypeID;
        var clientFirstName = row.clientFirstName;
        var clientLastName = row.clientLastName;
    
        // console.log(report);
    
        var ReportFields = { reportID, advisorID, clientID, orgID, reportTypeID, token: localStorage.getItem("bearer") };
        var client = { firstName: clientFirstName, lastName:clientLastName};
        var report = {reportTypeID: row.reportTypeID};
        this.snackBarService.add(`Downloading your ${Utils.formatReportTypeID(reportTypeID)} report`, 0);


        
        this.globalService.generateReport(ReportFields, client, report)
          .subscribe(
          resp => {
            // console.log('downloading report');
            this.loadingService.isLoading(false);
          },
          error => {
            this.error = <any>error;
            this.loadingService.isLoading(false);
          });
    
  }

  popUpMsg(scenario): void {
    const dialogRef = this.dialog.open(ResetHcQuestDataMsgComponent, {
      width: '500px',
      height: '300px'
    });
    if (scenario == 'resetHC') {
      dialogRef.afterClosed().subscribe(result => {
        if (result == 'reset') {
          this.updateClientProfileWithResetQuestionnaire('resetHC');
        }
        console.log('result', result);
      });
    }
    if (scenario == 'resetLTC') {
      dialogRef.afterClosed().subscribe(result => {
        if (result == 'reset') {
          this.updateClientProfileWithResetQuestionnaire('resetLTC');
        }
        console.log('result', result);
      });
    }
    if (scenario == 'resetHCLTC') {
      dialogRef.afterClosed().subscribe(result => {
        if (result == 'reset') {
          this.updateClientProfileWithResetQuestionnaire('resetHCLTC');
        }
        console.log('result', result);
      });
    }
    if (scenario == 'resetMMT') {
      dialogRef.afterClosed().subscribe(result => {
        if (result == 'reset') {
          this.updateClientProfileWithResetQuestionnaire('resetMMT');
        }
        console.log('result', result);
      });
    }
    if (scenario == 'resetSS') {
      dialogRef.afterClosed().subscribe(result => {
        if (result == 'reset') {
          this.updateClientProfileWithResetQuestionnaire('resetSS');
        }
        console.log('result', result);
      });
    }

  }

  updateClientProfileWithResetQuestionnaire(scenario) {
    console.log('scenario', scenario);
    if (scenario == 'resetSS') {
      if (this.client.clientProfile.Spouses.length > 1) {
        let spouses = [] = this.client.clientProfile.Spouses;
        for (let i=1; i <= spouses.length; i++) {
          this.client.clientProfile.Spouses.pop();
        }
      }
      if (this.client.clientProfile.Spouses.length > 0) {
        let spouses = [];
        if (this.client.clientProfile.Spouses[0].maritalStatus =='Married') {
          spouses[0] = { PIAYears: {} };
          spouses[0].maritalStatus = this.client.clientProfile.Spouses[0].maritalStatus;
          spouses[0].firstName = this.client.clientProfile.Spouses[0].firstName;
          spouses[0].lastName = this.client.clientProfile.Spouses[0].lastName;
          spouses[0].dob = this.client.clientProfile.Spouses[0].dob;
          spouses[0].gender = this.client.clientProfile.Spouses[0].gender;
          spouses[0].LifeExpectancy = this.client.clientProfile.Spouses[0].LifeExpectancy;
          spouses[0].retirementAge = this.client.clientProfile.Spouses[0].retirementAge;
          spouses[0].state = this.client.clientProfile.Spouses[0].state;
          if (this.client.clientProfile.Spouses[0].hasOwnProperty('HCT2D')) {
            spouses[0].HCT2D = this.client.clientProfile.Spouses[0].HCT2D;
          }
          if (this.client.clientProfile.Spouses[0].hasOwnProperty('HCHBP')) {
            spouses[0].HCHBP = this.client.clientProfile.Spouses[0].HCHBP;
          }
          if (this.client.clientProfile.Spouses[0].hasOwnProperty('HCC')) {
            spouses[0].HCC = this.client.clientProfile.Spouses[0].HCC;
          }
          if (this.client.clientProfile.Spouses[0].hasOwnProperty('HCCYrsDiag')) {
            spouses[0].HCCYrsDiag = this.client.clientProfile.Spouses[0].HCCYrsDiag;
          }
          if (this.client.clientProfile.Spouses[0].hasOwnProperty('HCHC')) {
            spouses[0].HCHC = this.client.clientProfile.Spouses[0].HCHC;
          }
          if (this.client.clientProfile.Spouses[0].hasOwnProperty('HCCD')) {
            spouses[0].HCCD = this.client.clientProfile.Spouses[0].HCCD;
          }
          if (this.client.clientProfile.Spouses[0].hasOwnProperty('HCCDYrsDiag')) {
            spouses[0].HCCDYrsDiag = this.client.clientProfile.Spouses[0].HCCDYrsDiag;
          }
          if (this.client.clientProfile.Spouses[0].hasOwnProperty('HCT')) {
            spouses[0].HCT = this.client.clientProfile.Spouses[0].HCT;
          }
          if (this.client.clientProfile.Spouses[0].hasOwnProperty('HCT1D')) {
            spouses[0].HCT1D = this.client.clientProfile.Spouses[0].HCT1D;
          }
          if (this.client.clientProfile.Spouses[0].hasOwnProperty('HCMS')) {
            spouses[0].HCMS = this.client.clientProfile.Spouses[0].HCMS;
          }
          if (this.client.clientProfile.Spouses[0].hasOwnProperty('HCDCW')) {
            spouses[0].HCDCW = this.client.clientProfile.Spouses[0].HCDCW;
          }
          if (this.client.clientProfile.Spouses[0].hasOwnProperty('HCFHDC')) {
            spouses[0].HCFHDC = this.client.clientProfile.Spouses[0].HCFHDC;
          }
          if (this.client.clientProfile.Spouses[0].hasOwnProperty('isLegalSpouse')) {
            spouses[0].HCFHDC = this.client.clientProfile.Spouses[0].isLegalSpouse;
          }
        }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('children')) {
        //   delete this.client.clientProfile.Spouses[0]['children'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('annualPensionValue')) {
        //   delete this.client.clientProfile.Spouses[0]['annualPensionValue'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('pensionStartMonth')) {
        //   delete this.client.clientProfile.Spouses[0]['pensionStartMonth'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('pensionStartYear')) {
        //   delete this.client.clientProfile.Spouses[0]['pensionStartYear'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('substantialEarningYear')) {
        //   delete this.client.clientProfile.Spouses[0]['substantialEarningYear'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('inRetFirstYearIncome')) {
        //   delete this.client.clientProfile.Spouses[0]['inRetFirstYearIncome'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('inRetStopWork')) {
        //   delete this.client.clientProfile.Spouses[0]['inRetStopWork'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('monthlyBenefitAmount')) {
        //   delete this.client.clientProfile.Spouses[0]['monthlyBenefitAmount'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('sSDesiredAgeYears')) {
        //   delete this.client.clientProfile.Spouses[0]['sSDesiredAgeYears'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('sSDesiredAgeMonths')) {
        //   delete this.client.clientProfile.Spouses[0]['sSDesiredAgeMonths'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('spousesSpouse')) {
        //   delete this.client.clientProfile.Spouses[0]['spousesSpouse'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('pension')) {
        //   delete this.client.clientProfile.Spouses[0]['pension'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('IncludePension')) {
        //   delete this.client.clientProfile.Spouses[0]['IncludePension'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('pensionMonth')) {
        //   delete this.client.clientProfile.Spouses[0]['pensionMonth'];
        // }
        // if (this.client.clientProfile.Spouses[0].hasOwnProperty('pensionYear')) {
        //   delete this.client.clientProfile.Spouses[0]['pensionYear'];
        // }
        // this.client.clientProfile.PIAYears = null;
        if (this.client.clientProfile.Spouses[0].maritalStatus =='Divorced' || this.client.clientProfile.Spouses[0].maritalStatus =='Widowed' || this.client.clientProfile.Spouses[0].maritalStatus == 'Single') {
          
          spouses[0] = { PIAYears: {} };
          spouses[0].maritalStatus = 'Single';//this.clientModelV2.maritalStatus.maritalStatus;
          spouses[0].pia = '';
          spouses[0].pension = '';
          // this.client.clientProfile.Spouses[0].maritalStatus = 'Single';
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('firstName')) {
          //   delete this.client.clientProfile.Spouses[0]['firstName'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('lastName')) {
          //   delete this.client.clientProfile.Spouses[0]['lastName'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('gender')) {
          //   delete this.client.clientProfile.Spouses[0]['gender'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('dobStr')) {
          //   delete this.client.clientProfile.Spouses[0]['dobStr'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('dob')) {
          //   delete this.client.clientProfile.Spouses[0]['dob'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('pia')) {
          //   delete this.client.clientProfile.Spouses[0]['pia'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('alive')) {
          //   delete this.client.clientProfile.Spouses[0]['alive'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('tenyears')) {
          //   delete this.client.clientProfile.Spouses[0]['tenyears'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('spouseCollectAtTimeOfPassing')) {
          //   delete this.client.clientProfile.Spouses[0]['spouseCollectAtTimeOfPassing'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('monthlyBenefitAtPassing')) {
          //   delete this.client.clientProfile.Spouses[0]['monthlyBenefitAtPassing'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('exSpouseLifeExpectancy')) {
          //   delete this.client.clientProfile.Spouses[0]['exSpouseLifeExpectancy'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('expectedClaimAgeYears')) {
          //   delete this.client.clientProfile.Spouses[0]['expectedClaimAgeYears'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('expectedClaimAgeMonths')) {
          //   delete this.client.clientProfile.Spouses[0]['expectedClaimAgeMonths'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('exSpouseDateOfBirth')) {
          //   delete this.client.clientProfile.Spouses[0]['exSpouseDateOfBirth'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('exSpouseClaimAgeYears')) {
          //   delete this.client.clientProfile.Spouses[0]['exSpouseClaimAgeYears'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('exSpouseClaimAgeMonths')) {
          //   delete this.client.clientProfile.Spouses[0]['exSpouseClaimAgeMonths'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('yearOfStatement')) {
          //   delete this.client.clientProfile.Spouses[0]['yearOfStatement'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('yearAtTimeOfPassing')) {
          //   delete this.client.clientProfile.Spouses[0]['yearAtTimeOfPassing'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('SubstantialEarningYearsDetails')) {
          //   delete this.client.clientProfile.Spouses[0]['SubstantialEarningYearsDetails'];
          // }
          // if (this.client.clientProfile.Spouses[0].hasOwnProperty('YearOfStatement')) {
          //   delete this.client.clientProfile.Spouses[0]['YearOfStatement'];
          // }
          // "spouseCollectAtTimeOfPassing":false,"monthlyBenefitAtPassing":0,"exSpouseLifeExpectancy":89,"expectedClaimAgeYears":"67","expectedClaimAgeMonths":"7","exSpouseDateOfBirth":"","exSpouseClaimAgeYears":"","exSpouseClaimAgeMonths":"",
          // "yearOfStatement":"","yearAtTimeOfPassing":"","SubstantialEarningYearsDetails":{"startYear":"","endYear":"","seyTable":[],"details":[],"staticValue":false},"YearOfStatement":2023}]

        }
        this.client.clientProfile.Spouses = spouses;
      }


    }
    console.log('this.client.clientProfile.Spouses 02',this.client.clientProfile.Spouses);
    var ClientProfile = {
      ClientID: this.client.clientProfile.ClientID,
      MaritalStatus: this.client.clientProfile.MaritalStatus,
      CurrentIncome: scenario == 'resetSS' ? null :this.client.clientProfile.CurrentIncome,
      IRR: scenario == 'resetSS' ? null :this.client.clientProfile.IRR ,
      RetirementAge: this.client.clientProfile.RetirementAge,
      RetirementState: this.client.clientProfile.RetirementState,
      SpouseID: this.client.clientProfile.SpouseID,
      LifeExpectancy: this.client.clientProfile.LifeExpectancy,
      HCHBP: this.client.clientProfile.HCHBP ? 1 : 0,
      HCHC: this.client.clientProfile.HCHC ? 1 : 0,
      HCT2D: this.client.clientProfile.HCT2D ? 1 : 0,
      HCCD: this.client.clientProfile.HCCD ? 1 : 0,
      HCC: this.client.clientProfile.HCC ? 1 : 0,
      HCT: this.client.clientProfile.HCT ? 1 : 0,

      HCALZ: this.client.clientProfile.HCALZ ? 1 : 0,
      HCPARK: this.client.clientProfile.HCPARK ? 1 : 0,
      HCAMP: this.client.clientProfile.HCAMP ? 1 : 0,
      HCPTSD: this.client.clientProfile.HCPTSD ? 1 : 0,
      HCOBS: this.client.clientProfile.HCOBS ? 1 : 0,

      Spouses: JSON.stringify(this.client.clientProfile.Spouses),
      Children: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? this.client.clientProfile.Children : null,//JSON.stringify(this.client.clientProfile.Children),
      Pension:  scenario == 'resetSS' ? null : this.client.clientProfile.Pension,
      PensionMonths: scenario == 'resetSS' ? null : this.client.clientProfile.PensionMonths,
      PensionYears: scenario == 'resetSS' ? null : this.client.clientProfile.PensionYears,
      SubstantialEarningYears: scenario == 'resetSS' ? null : this.client.clientProfile.SubstantialEarningYears,
      IncludePension: this.client.clientProfile.IncludePension,
      PIA: scenario == 'resetSS' ? null :this.client.clientProfile.PIA,
      PIAYears: (!this.client.clientProfile.PIAYears || this.client.clientProfile.PIAYears == 'null') ? null : JSON.stringify(this.client.clientProfile.PIAYears),
      UseNationalAverage: this.client.clientProfile.UseNationalAverage,
      IsRunReportWithSpouse: this.client.clientProfile.IsRunReportWithSpouse,
      IsLegalSpouse: this.client.clientProfile.IsLegalSpouse,
      HCT1D: this.client.clientProfile.HCT1D ? 1 : 0,
      HCMS: this.client.clientProfile.HCMS ? 1 : 0,
      HCDCW: this.client.clientProfile.HCDCW ? 1 : 0,
      HCFHDC: this.client.clientProfile.HCFHDC ? 1 : 0,
      IsPrivHealthIns: scenario == 'resetHC' || scenario == 'resetHCLTC' ? null : this.client.clientProfile.IsPrivHealthIns,
      CoverageType: scenario == 'resetHC' || scenario == 'resetHCLTC' ?  null : this.client.clientProfile.CoverageType,
      PremiumType: scenario == 'resetHC' || scenario == 'resetHCLTC' ? null : this.client.clientProfile.PremiumType,
      Premiums:  scenario == 'resetHC' || scenario == 'resetHCLTC' ? null : this.client.clientProfile.Premiums,
      IsHSApplySpouse: scenario == 'resetHC' || scenario == 'resetHCLTC' ? null : this.client.clientProfile.IsHSApplySpouse,
      IsSpousePrivHealthIns: scenario == 'resetHC' || scenario == 'resetHCLTC' ? null : this.client.clientProfile.IsSpousePrivHealthIns,
      SpouseCoverageType: scenario == 'resetHC' || scenario == 'resetHCLTC' ? null : this.client.clientProfile.SpouseCoverageType,
      SpousePremiumType: scenario == 'resetHC' || scenario == 'resetHCLTC' ? null : this.client.clientProfile.SpousePremiumType,
      SpousePremiums: scenario == 'resetHC' || scenario == 'resetHCLTC' ? null : this.client.clientProfile.SpousePremiums,
      Bracket: scenario == 'resetHC' || scenario == 'resetHCLTC' || scenario == 'resetMMT' ? null : this.client.clientProfile.Bracket,
      InflationRate: scenario == 'resetHC' || scenario == 'resetHCLTC' || scenario == 'resetMMT' || scenario == 'resetSS'  ? null : this.client.clientProfile.InflationRate,
      HouseholdYearOneIncome: scenario == 'resetHC' || scenario == 'resetHCLTC' || scenario == 'resetMMT' || scenario == 'resetSS' ? null : this.client.clientProfile.HouseholdYearOneIncome,
      HouseholdYearOneIncomeChangeYear: null,
      InRetirementInflationRate: scenario == 'resetHC' || scenario == 'resetHCLTC' || scenario == 'resetMMT' || scenario == 'resetSS' ? null : this.client.clientProfile.InRetirementInflationRate,
      MAGIPercentIncome: scenario == 'resetHC' || scenario == 'resetHCLTC' || scenario == 'resetMMT' || scenario == 'resetSS'  ? null : this.client.clientProfile.MAGIPercentIncome,
      OOPCosts: scenario == 'resetHC' || scenario == 'resetHCLTC' ? null : this.client.clientProfile.OOPCosts,
      SpouseOOPCosts: scenario == 'resetHC' || scenario == 'resetHCLTC' ? null : this.client.clientProfile.SpouseOOPCosts,
      ClientMetroArea: scenario == 'resetLTC' || scenario == 'resetHCLTC' ? null: this.client.clientProfile.ClientMetroArea,
      SpouseMetroArea: scenario == 'resetLTC' || scenario == 'resetHCLTC' ? null: this.client.clientProfile.SpouseMetroArea,
      InRetFirstYearIncome: scenario == 'resetSS' ? null : this.client.clientProfile.InRetFirstYearIncome,
      InRetStopWorkAge: scenario == 'resetSS' ? null : this.client.clientProfile.InRetStopWorkAge,
      MonthlyBenefitAmount: scenario == 'resetSS' ? null : this.client.clientProfile.MonthlyBenefitAmount,
      SSDesiredAgeYears : scenario == 'resetSS' ? null : this.client.clientProfile.SSDesiredAgeYears,
      SSDesiredAgeMonths: scenario == 'resetSS' ? null : this.client.clientProfile.SSDesiredAgeMonths
     }

    var UserModel = {
      ID: this.client.client ? this.client.client.ID : 0,
      FirstName: this.client.client.FirstName,
      LastName: this.client.client.LastName,
      AdvisorID: this.client.client.AdvisorID,
      OrganizationID: this.client.client.OrganizationID,
      Username: this.client.client.Username,
      GenderID: this.client.client.GenderID,
      DOB: this.client.client.DOB,
      Email: this.client.client.Email,
      Phone: this.client.client.Phone,
      Address: this.client.client.Address,
      City: this.client.client.City,
      State: this.client.client.State,
      Zip: this.client.client.Zip,
    }
    var RiskTolerance = null;
    var AdditionalQuestion = null;
    if ( scenario == 'resetHC' || scenario == 'resetHCLTC' || scenario == 'resetSS') {
      if (this.client.additionalQuestion) {
        AdditionalQuestion = {
          Firm: this.client.additionalQuestion.Firm,
          PlanSponsor: this.client.additionalQuestion.PlanSponsor,
          Wholesaler: this.client.additionalQuestion.Wholesaler,
          SendReportTo: this.client.additionalQuestion.SendReportTo,
          RepName: this.client.additionalQuestion.RepName,
          MeetingReference: this.client.additionalQuestion.MeetingReference,
          FromHCLTCComb: 'HC',
          IsDeleted: true
        }
      }
    }

    var MidRetirementAdj = null;
    if ( scenario == 'resetHC' || scenario == 'resetHCLTC' || scenario == 'resetMMT' || scenario == 'resetSS') {
    if (this.client.midRetirementAdj) {
      MidRetirementAdj = {
        Year: this.client.midRetirementAdj.Year,
        ReductionDollar: this.client.midRetirementAdj.ReductionDollar,
        ReductionPerc: this.client.midRetirementAdj.ReductionPerc,
        IncomeInflationRate:  this.client.midRetirementAdj.IncomeInflationRate,
        IsDeleted: true
      }
    }
  }


    var modalData;
    let LstMAGIProj = JSON.parse(this.client.magiProjs);
    let newMAGIProj = [];
    if ( scenario == 'resetHC' || scenario == 'resetHCLTC' || scenario == 'resetSS') {
    if (LstMAGIProj) {
      for(var data of LstMAGIProj) {
        modalData = {
          ClientID: data.ClientID,
          Year: Number(data.Year),
          Age: data.Age,
          Income: data.Income ? Number(Utils.removeCurrencyFormatting(data.Income.toString())) : null,
          MAGI: data.MAGI ? Number(Utils.removeCurrencyFormatting(data.MAGI.toString())): null,
          Bracket: data.Bracket ? Number(data.Bracket): null,
          IsDeleted: true
        }
        newMAGIProj.push(modalData);
      }
    }
  }

    console.log('UserModel', UserModel)
    console.log('ClientProfile', ClientProfile);
    console.log('AdditionalQuestion', AdditionalQuestion);
    console.log('MidRetirementAdj', MidRetirementAdj);
    console.log('LstMAGIProj', LstMAGIProj);
   
    this.globalService.createClient(UserModel, ClientProfile , RiskTolerance, AdditionalQuestion, MidRetirementAdj, newMAGIProj)
    .subscribe(
      resp => {
        if (scenario == 'resetHC') {
          this.navigateTo('HC', 'new');
        }
        if (scenario == 'resetLTC') {
          this.navigateTo('LTC', 'new')
        }
        if (scenario == 'resetHCLTC') {
          this.navigateTo('COMBO', 'new')
        }
        if (scenario == 'resetMMT') {
          this.navigateTo('MMT', 'new')
        }
        if (scenario == 'resetSS') {
          this.navigateTo('SS', 'new')
        }


      },
      error => {

      });
  }

  ssCantContinue(isDisabled){
    if(isDisabled){
      let isLifeExpectamcyLowerthanSixtyTwo = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? ((this.client.clientProfile.LifeExpectancy < 62 || this.client.clientProfile.Spouses[0].LifeExpectancy < 62) ? true: false): (this.client.clientProfile.LifeExpectancy < 62 ? true: false);
      if (isLifeExpectamcyLowerthanSixtyTwo) {
        if (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
          if (this.client.clientProfile.LifeExpectancy < 62 && this.client.clientProfile.Spouses[0].LifeExpectancy < 62) {
            const dialogRef = this.matDialog.open(MessageComponent, {     
              data: { title: 'Cannot Continue', message: 'Client and Spouse Life Expectancy is lower than Social Security eligibility. A report cannot currently be run. <br/> To modify Life Expectancy, open the Client Info Editor from the right side of the client hub page.' }
            });
          } else if (this.client.clientProfile.LifeExpectancy < 62) {
            const dialogRef = this.matDialog.open(MessageComponent, {     
              data: { title: 'Cannot Continue', message: 'Client Life Expectancy is lower than Social Security eligibility. A report cannot currently be run. <br/> To modify Life Expectancy, open the Client Info Editor on the right side of your screen.' }
            });
          } else {
            const dialogRef = this.matDialog.open(MessageComponent, {     
              data: { title: 'Cannot Continue', message: 'Spouse Life Expectancy is lower than Social Security eligibility. A report cannot currently be run. <br/> To modify Life Expectancy, open the Client Info Editor from the right side of the client hub page.' }
            });
          }
        } else {
          if (this.client.clientProfile.LifeExpectancy < 62) {
            const dialogRef = this.matDialog.open(MessageComponent, {     
              data: { title: 'Cannot Continue', message: 'Client Life Expectancy is lower than Social Security eligibility. A report cannot currently be run. <br/> To modify Life Expectancy, open the Client Info Editor on the right side of your screen.' }
            });
          } 
        }
      }      
    }

  }

}
